export default {
    spanish: 'Spanish',
    english: 'English',
    addPrinter: {
      title: "Add Printer",
      detectPrinters: "Auto-Detect Printers",
      printerName: "Printer Name",
      printerType: "Printer Type",
      laser: "Laser Printer",
      receipt: "Receipt Printer",
      barcode: "Barcode Printer",
      connectionType: "Connection Type",
      network: "Network",
      ipAddress: "IP Address",
      port: "Port",
      driverType: "Driver Type",
      printSpeed: "Print Speed",
      autoCutter: "Auto Cutter",
      cashDrawerPort: "Cash Drawer Port",
      printDensity: "Print Density",
      savePrinter: "Save Printer",
      detectionCompleted: "Printer detection completed.",
      fillAllFields: "Please fill in all required fields.",
      success: "Printer added successfully!",
      scanning: "Scanning for printers...",
      detectionSuccess: "Printer detected successfully!",
      noPrintersFound: "No printers found.",
      detectionError: "Error detecting printers."
    },
    backoffice: {
      printerManager: {
        title: "Printer Manager",
        printers: "Printers",
        select: "Select",
        discoverPrinters: "Discover Printers",
        showAddPrinter: "Add Printer",
        printTest: "Print Test Page",
        scanBluetooth: "Scan for Bluetooth Printers",
        printerName: "Printer Name",
        printerType: "Printer Type",
        laser: "Laser Printer (A4)",
        receipt: "Receipt Printer",
        barcode: "Barcode Printer",
        autoCutter: "Auto Cutter",
        driverType: "Driver Type",
        connectionType: "Connection Type",
        ipAddress: "IP Address",
        port: "Port",
        mac: "MAC Address",
        isDefault: "Default",
        add: "Add",
        cancel: "Cancel",
        noPrintersFound: "No printers found.",
        printSentSuccess: "✅ Print sent successfully to network printer.",
        printFailedBackend: "❌ Print failed on backend.",
        networkPrintError: "❌ Network Print Error: {error}",
        usbPrintError: "USB Print Error. Check connections!",
        noUSBPrinters: "No USB printers detected!",
        bluetoothPrintError: "Bluetooth Print Error: Check connection!",
        printFailed: "⚠️ Print failed. Please check the printer connection and try again.",
        selectPrinterType: "Select Printer Connection Type",
        inputPlaceholder: "Select a type connection",
        pleaseSelectPrinterType: "Please select a printer type.",
        invalidPrinterType: "Invalid printer type selected.",
        scannedFromBLE: "Scanned from BLE: {barcode}"
      },
      bleScanner: {
        title: "BLE Scanner & Printer",
        deviceType: "Device Type",
        scanner: "Barcode Scanner",
        printer: "Printer",
        scanDevices: "Scan for BLE Devices",
        unnamedDevice: "Unnamed Device",
        connect: "Connect",
        scannedBarcode: "Scanned Barcode:",
        printData: "Print Data",
        enterPrintText: "Enter text to print",
        sendToPrinter: "Send to Printer",
        bleScanError: "BLE Scan Error: {error}",
        connectionSuccess: "Connected to {device}",
        connectionError: "Connection Error: {error}",
        notificationError: "Notification Error: {error}",
        scanned: "Scanned: {barcode}",
        noPrinterOrData: "No printer connected or print data empty.",
        printDataSent: "Print data sent to printer.",
        printError: "Print Error: {error}"
      },
      interactions: {
        lastContacted: 'Last Contacted',
        notesLastContacted: 'Notes Last Contacted',
        nextFollowUp: 'Next Follow-Up',
        notesNextFollowUp: 'Notes Next Follow-Up',
        preferredContactTime: 'Preferred Contact Time',
        notesContactToTime: 'Notes Contact To Time',
        selectSubscriber: 'Select Subscriber',
        selectSubscriberDescription: 'Select a subscriber to add or view their information',
        selectSubscriberInput: 'Select a subscriber',
        selectSubscriberInputPlaceholder: 'Select a subscriber',
        createSubscriber: 'Create Subscriber',
        cancel: 'Cancel',
        //customers
        selectCustomer: 'Select Customer',
        selectCustomerDescription: 'Select a customer to add or view their information',
        selectCustomerInput: 'Select a customer',
        selectCustomerInputPlaceholder: 'Select a customer',
        createCustomer: 'Create Customer',
      },
      cCardSaved:{
        paymentManagement: 'Payment Management',
        clickToManageCards: 'Click here to add or view your cards on file',
        creditCards: 'Credit Cards',
        addCreditCard: 'Add Credit Card',
      },
      virtualTerminal: {
        acordeon1: {
          title: 'Payment/Authorization Information',
          subtitle:
            'Accept Payment Method American Express, Discover Mastercard',
          cardNumber: 'Card Number',
          expirationDate: 'Expiration Date',
          amount: 'Amount'
        },
        acordeon2: {
          title: 'Order Information',
          subscriptionName: 'Subscription Name',
          invoice: 'Invoice #',
          description: 'Description',
          placeholder: 'Enter more information here...'
        },
        acordeon3: {
          title: 'Subscription Interval',
          subtitle: 'Select how often customer is billed.',
          selectOption: 'Select Option',
          interval1: 'Monthly',
          interval2: 'Quarterly',
          interval3: 'Semi-annual',
          interval4: 'Annualy'
        },
        acordeon4: {
          title: 'Subscription Duration',
          startDate: 'Start Date',
          noEnd: 'No End Date (Ongoing subscription)',
          endDate: 'End Date',
          endAfter: 'End After'
        },
        acordeon5: {
          title: 'Payment',
          nameAcount: 'Name on account',
          paymentType: 'Payment Type',
          creditCard: 'Credit Card',
          subscriptionName: 'Subscription Name',
          trialAmount: 'Trial Amount',
          firstName: 'First Name',
          sameAsBilling: 'Same As Billing'
        }
      },
      worksheetStatus: {
        draft: 'Draft',
        opened: 'Opened',
        closed: 'Closed',
        worksheetDetail: 'Worksheet Details',
        fields: {
          responsable: 'Responsible',
          startDate: 'Start Date',
          endDate: 'End Date',
          workers: 'Workers'
        },
        tooltip: {
          staffWorker: 'Add staff worker',
          resetAllCalendar: 'Reset all calendars',
          showCalendarDetails: 'Show calendar details',
          resetCalendar: 'Reset this calendar',
          removeStaffWorker: 'Remove staff worker',
          debit: 'These are your expenses. Money that is paid out.',
          credit: 'These are your income. Money that comes in to you.',
          payee: 'This is who paid you or you paid.',
          category: 'This is the type of payment or credit.',
          bestRepresentation: 'This is the systems best guess of the category.'
        },
        message: {
          totalHour: 'Total hours worked:',
          hours: 'hours',
          with: 'with',
          minutes: 'minutes',
          typeMessage: 'Type message Here...'
        },
        button: {
          saveDraft: 'Save Draft',
          saveOpen: 'Save and Open',
          close: 'Close',
          addShift: 'Add Shift',
          changeworksheetRequest: 'Change Request'
        }
      },
      mastercard:{
        accountInfo: 'Account Information',
        mastercardUserDetails: 'Mastercard User Details',
        seeLinedAccounts: 'View Linked Accounts',
        addMoreBanks: 'Add More Banks',
        linkedBanks: 'Linked Accounts',
        viewTransactions: 'View Transactions',
        linesPerPage: 'How many lines per page',
      },
      transactionData: {
        revenue: "Revenue",
        revenueDescription: "Toggle this switch if the transaction is a revenue entry.",
        transactionId: "Transaction ID",
        transactionIdDescription: "Enter the unique transaction ID associated with this transaction.",
        transactionAmount: "Transaction Amount (USD)",
        transactionAmountDescription: "Enter the transaction amount in USD. This is the amount involved in the transaction.",
        accountId: "Account ID",
        accountIdDescription: "Enter the unique account ID associated with the transaction.",
        customerId: "Customer ID",
        customerIdDescription: "Enter the unique customer ID associated with the transaction.",
        transactionStatus: "Transaction Status",
        transactionStatusDescription: "Select the current status of the transaction from the available options.",
        statusOptions: {
          active: "Active",
          pending: "Pending",
          completed: "Completed",
          failed: "Failed",
          cancelled: "Cancelled"
        },
        memo: "Memo",
        memoDescription: "Enter any additional notes or memo for the transaction.",
        transactionType: "Transaction Type",
        transactionTypeDescription: "Select the transaction type for this transaction.",
        transactionDate: "Transaction Date",
        transactionDateDescription: "Select the date when the transaction occurred.",
        typeOptions: {
          debit: "Debit",
          credit: "Credit",
          transfer: "Transfer",
          payment: "Payment",
          withdrawal: "Withdrawal",
          deposit: "Deposit"
        },
        postedDate: "Posted Date",
        postedDateDescription: "Select the date when the transaction was posted.",
        createdDate: "Created Date",
        createdDateDescription: "Select the date when the transaction was created.",
        firstEffectiveDate: "First Effective Date",
        firstEffectiveDateDescription: "Select the first effective date for the transaction.",
        effectiveDate: "Effective Date",
        effectiveDateDescription: "Select the effective date for the transaction.",
        optionExpireDate: "Option Expire Date",
        optionExpireDateDescription: "Select the option expire date if applicable.",
        checkNumber: "Check Number",
        checkNumberDescription: "Enter the check number if applicable. Leave blank if not applicable.",
        escrowAmount: "Escrow Amount (USD)",
        escrowAmountDescription: "Enter the escrow amount if applicable. This is the amount held in escrow for the transaction.",
        transactionFeeAmount: "Transaction Fee Amount (USD)",
        transactionFeeAmountDescription: "Enter the fee amount if applicable. This is the fee charged for processing the transaction.",
        suspenseAmount: "Suspense Amount (USD)",
        suspenseAmountDescription: "Enter the suspense amount if applicable. This is used for transactions that are temporarily held or pending.",
        interestAmount: "Interest Amount (USD)",
        interestAmountDescription: "Enter the interest amount if applicable. This is the amount of interest accrued on the transaction.",
        principalAmount: "Principal Amount (USD)",
        principalAmountDescription: "Enter the principal amount if applicable. This is the original sum of money borrowed or invested, excluding any interest or fees.",
        optionStrikePrice: "Option Strike Price (USD)",
        optionStrikePriceDescription: "Enter the option strike price if applicable. This is the price at which the option can be exercised.",
        unitQuantity: "Unit Quantity",
        unitQuantityDescription: "Enter the unit quantity if applicable. This is the number of units involved in the transaction, such as items purchased or shares traded.",
        unitPrice: "Unit Price (USD)",
        unitPriceDescription: "Enter the unit price if applicable. This is used for transactions involving securities or investments.",
        transactionCategorization: "Transaction Categorization",
        normalizedPayeeName: "Normalized Payee Name",
        normalizedPayeeNameDescription: "Enter the name of the payee in a standardized format. This is useful for ensuring consistency in records.",
        transactionCategory: "Transaction Category",
        transactionCategoryDescription: "Enter the category of the transaction, such as 'sale', 'purchase', or 'transfer'.",
        customCategory: "Custom Category",
        customCategoryDescription: "Enter a custom category if applicable. This is for transactions that do not fit into predefined categories.",
        city: "City",
        cityDescription: "Enter the city related to the transaction.",
        state: "State",
        stateDescription: "Enter the state or region where the transaction occurred.",
        postalCode: "Postal Code",
        postalCodeDescription: "Enter the postal code of the location associated with the transaction.",
        country: "Country",
        countryDescription: "Enter the country where the transaction took place.",
        bestRepresentation: "Best Representation",
        bestRepresentationDescription: "Enter the best representation for the transaction, which could be a general description or classification.",
        runningBalanceAmountUSD: "Running Balance Amount (USD)",
        runningBalanceAmountUSDDescription: "Enter the running balance amount in USD, which is the ongoing balance after the transaction is processed.",
        subaccountSecurityType: "Subaccount Security Type",
        subaccountSecurityTypeDescription: "Enter the security type associated with the subaccount, if applicable.",
        commissionAmountUSD: "Commission Amount (USD)",
        commissionAmountUSDDescription: "Enter the commission amount in USD, if applicable. This is the fee charged for the transaction.",
        tickerSymbol: "Ticker Symbol",
        tickerSymbolDescription: "Enter the ticker symbol for the asset or security involved in the transaction.",
        investmentTransactionType: "Investment Transaction Type",
        investmentTransactionTypeDescription: "Enter the type of investment transaction, such as 'buy', 'sell', or 'dividend'.",
        taxesAmountUSD: "Taxes Amount (USD)",
        taxesAmountUSDDescription: "Enter the amount of taxes related to the transaction, in USD.",
        currencySymbol: "Currency Symbol",
        currencySymbolDescription: "Enter the symbol of the currency used in the transaction, such as '$' for USD or '€' for EUR.",
        incomeType: "Income Type",
        incomeTypeDescription: "Enter the type of income, such as 'wage', 'interest', or 'capital gains'.",
        splitDenominator: "Split Denominator",
        splitDenominatorDescription: "Enter the denominator for any fractional or split transactions, if applicable.",
        splitNumerator: "Split Numerator",
        splitNumeratorDescription: "Enter the split numerator if applicable. This value is used for transactions that involve splitting amounts across multiple categories or accounts.",
        sharesPerContract: "Shares Per Contract",
        sharesPerContractDescription: "Enter the number of shares per contract if applicable. This is relevant for investment transactions or contracts that involve shares.",        
        subAccountFund: "Sub Account Fund",
        subAccountFundDescription: "Enter the sub account fund if applicable.",        
        securityId: "Security ID",
        securityIdDescription: "Enter the security ID if applicable.",        
        securityIdType: "Security ID Type",
        securityIdTypeDescription: "Enter the security ID type if applicable.",
        saveTransaction: "Save Transaction"
      },
      multiActionText: {
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        deleteSelected: 'Delete Selected',
      },
      communicationResponse: {
        failedToLoad: 'Failed to Load',
        emailError: 'Could not fetch email responses. Please try again later.',
        smsError: 'Could not fetch SMS responses. Please try again later.',
      },
      interactionHistory: {
        historyInteraction: "History Interaction",
        lastContacted: "Last Contacted",
        notesLastContacted: "Note",
        nextFollowUp: "Next Follow-up",
        notesNextFollowUp: "Note",
        preferredContactTime: "Preferred Contact Time",
        preferredContactToTime: "To",
        notesContactToTime: "Note",
        noHistory: "No history"
      },    
      imenuPayFlex:{
        invoiceId: "Invoice ID",
        planName: "Plan Name",
        amount: "Amount",
        totalAmount: "Total Amount",
        subscription: "Subscription",
        schedulePayment: "Schedule of Payment",
        recurringPayment: "Recurring Payment?",
        frequency: "Frequency",
        payEvery: "Pay every",
        customInterval: "Custom Interval",
        customIntervalNote: "Payment will be made every {days} days",
        payStartsOn: "Pay starts on",
        payUntil: "Pay until",
        endsAfterDate: "Payment ends after",
        endsAfterOccurrences: "Payment ends after {count} occurrences",
        howToPay: "How do you want to pay?",
        creditCard: "Credit Card",
        banking: "Banking",
        placeholderCustomInterval: "2",
        placeholderOccurrences: "Example: 2",
      },
      googleCalendar: {
        createEvent: "Create Event",
        title: "Title",
        description: "Description",
        location: "Location",
        startTime: "Start Time",
        endTime: "End Time",
        timeZone: "Time Zone",
        selectTimeZone: "Select Time Zone",
        attendeeEmail: "Attendee Email",
        attendeeEmailPlaceholder: "client@example.com",
        attendeeEmailLabel: "Attendee Email",
        addAttendee: "Add Attendee",
        providerEmail: "Provider Email",
        providerEmailPlaceholder: "provider@example.com",
        color: "Color",
        selectColor: "Select a color",
        submitEvent: "Create Event",
        updateEvent: "Update Event",
        upcomingEvents: "Upcoming Events",
        deleteConfirmationTitle: "Are you sure?",
        deleteConfirmationText: "You won't be able to revert this!",
        deleteNotificationCheckbox: "Do you want to notify them that the event is cancelled?",
        deleteConfirmButton: "Yes, delete it!",
        deleteCancelButton: "Cancel",
        deleteSuccessTitle: "Deleted!",
        deleteSuccessText: "Event has been deleted.",
        deleteErrorTitle: "Error!",
        deleteErrorText: "Unable to delete the event."
      },        
      bulkSend: {
        title: "What is Bulk Send?",
        text: "Bulk Send allows you to send multiple emails and SMS messages at once, making communication more efficient.",
        confirmButtonText: "Got it!",
        selectRecipientsTitle: "Select Recipients",
        selectAllCustomers: "Select All Customers",
        selectAllSubscribers: "Select All Subscribers",
        bulkSendOptionsTitle: "Bulk Send Options",
        sendEmail: "Send Bulk Email",
        sendSMS: "Send Bulk SMS",
        whenToSend: "When do you want to send it?",
        sendNow: "Send Now",
        schedule: "Schedule",
        cancel: "Cancel",
        validationSelectMethod: "Please select at least one method.",
        validationScheduledTime: "Scheduled time must be in the future.",
        successSent: "Sent successfully!",
        successScheduled: "Scheduled successfully!",
        error: "An error occurred.",
        subject: "Bulk Notification",
        body: "Your scheduled message content here.",
        bulkSend:"Bulk Send",
        validationSelectRecipients: "Select at least one recipient"
      },      
      table: {
        transactionDate: 'Transaction Date',
        customerId: 'Customer ID',
        status: 'Status',
        debit: 'Debit',
        credit: 'Credit',
        description: 'Description',
        memo: 'Memo',
        payee: 'Payee',
        category: 'Category',
        bestRepresentation: 'Best Representation',
        country: 'Country',
        action: 'Action'
      },
      emailTest: {
        sendTest: 'Send Test Email',
        message:
          "This is a sample message. Please, don't respond to this message.",
        subject: 'iMenuApps® support.',
        success: 'Email was sent successfully.',
      },
      menu: {
        titleQuoteConverted: 'Quote converted to Invoice',
        quoteConverted: 'The quote has been converted to an invoice successfully.',
        transactionData: 'Transaction Data',
        bankAccountConnection: 'Bank Account Connection',
        viewTransactions: 'View Transactions',
        validationPhone: 'The phone number must contain exactly 10 digits.',
        restaurantAdministration: 'Admin',
        savedSuccesful: 'The setting was changed successfully',
        savedFailed: 'There was an error in saving settings.',
        lostChanges: 'Your changes will be lost if you leave this page!',
        sure: 'Are you sure?',
        wontRevert: "You won't be able to revert this!",
        yesVoid: 'Yes, void payment!',
        voided: 'Voided!',
        voidedSuccessfully: 'The payment has been voided successfully.',
        yesRefund: 'Yes, refund!',
        refund: 'Refunded!',
        refundSuccessfully: 'The refund was successfully processed.',
        merchantQuoteNotes: 'Merchant Quotes Notes',
        merchantInvoiceNotes: 'Merchant Invoice Notes',
        titleInformationIncomplete: 'Required information',
        informationIncomplete: 'Please complete all required fields.',
        yes: 'Yes',
        emailSend: 'Email sent',
        emailSendTo: 'The email with the invoice has been sent correctly to',
        questionSendEmail: 'Send an email?',
        dialogSendEmail: 'Are you sure you want to send the email to',
        addNewSendEmail: 'Add another email address',
        send: 'Send',
        close: 'Close',
        alertEmailSend: 'Email sent',
        alertEmailSendTo: 'Successfully sent to',
        session: 'Session',
        foodServices: 'Products/Services',
        ordersTickets: 'Orders/Tickets',
        reservationsDeliveries: 'Reservations/Deliveries',
        restaurantAdministration: 'Administration',
        report: 'Reports',
        sales: 'Sales',
        staffOccupationsCustomersDrivers: 'Staff/Occupations/Customers/Drivers',
        marketing: 'Marketing',
        settings: 'Settings',
        merchantSettings: 'Merchant Settings',
        revenue: 'Revenue',
        revenueInfo:
          'The Revenue section in iMenuApps® is your centralized hub for managing all income-generating activities within your business. This section allows you to efficiently handle various tasks related to revenue and financial transactions, ensuring that your business operations are smooth and profitable. Here’s what you can do in the Revenue section: 1.   View/Create Orders: Manage customer orders from creation to completion. This feature allows you to keep track of all orders, ensuring they are processed 2.   Reservations: Manage and track reservations for your services, whether for dining, events, or other bookings. This feature ensures that you can effectively manage your bookings and avoid overbooking. 3.   Quotes: Create and manage quotes for potential revenue, allowing you to provide customers with detailed pricing and service information before finalizing a sale. Easily convert accepted quotes into invoices to streamline the revenue process. 4.   Invoices: Generate, manage, and track all customer invoices. This feature ensures accurate billing and provides a clear record of all revenue transactions. 5.   Shipping: Coordinate and manage shipping details for orders, including the preparation, scheduling, and dispatching of shipments. 6.   Track Shippings: Monitor the status and progress of shipments in real-time, ensuring that your deliveries are on schedule and customers are kept informed. 7.   Subscription Billing: Manage recurring billing for subscription services, ensuring that customers are billed accurately and on time for ongoing services. 8.   Deliveries: Oversee and manage all delivery activities, from order fulfillment to the final delivery to customers, ensuring that goods and services reach their destination efficiently. 9.        Pickup Requests: Handle customer requests for order pickups, allowing them to retrieve their orders directly from your business location.',
        adminInfo:
          'The Administration section in iMenuApps® serves as the control center for managing various operational and logistical aspects of your business. Here’s an overview of the features and tasks you can manage within this section: 1.   Tables Management: •   Configure and manage your business’s table setup, including the number of tables, their arrangement, and seating capacity. •   Optimize space for reservations and ensure efficient table turnover. 2.   Tax Management: •   Set and manage tax rates applicable to your selection items and services. •   Ensure accurate tax application on all transactions according to local regulations. 3.   Delivery Management: •   Oversee your delivery operations from assignment to completion. •   Track orders in real-time and provide customers with updates on their deliveries. •   Ensure efficient and timely delivery services to enhance customer satisfaction. 4.   Staff Management: •   Manage your team of staff, including adding new staff members, updating roles, and managing permissions. •   Set up roles and assign tasks to ensure smooth operations. 5.   Drivers Management: •   Manage your delivery drivers, assign delivery tasks, and track their performance. •   Ensure that your delivery service runs smoothly and efficiently. 6.   Permission Roles: •   Define and manage roles and permissions for staff and administrators. •   Ensure that each team member has access to the tools and information they need to perform their duties effectively. 7.   Worksheet Management: •   Track and manage staff working hours and schedules. •   Ensure accurate timekeeping and payroll processing. 8.   Occupations Management: •   Organize and manage different staff occupations within your business. •   Keep your team structured and roles well-defined. 9.   Customers Management: •   Manage customer information, track orders, and maintain customer profiles. •   Enhance customer service by having all customer details easily accessible. 10.   Credits Management: •   Handle customer credits efficiently, apply credits to orders, and keep track of credit balances. 11.   Selections Management: •   Design and manage your business’s selections, including creating new selections, updating items, and managing pricing. 12.   Categories Management: •   Organize your selections items into categories for easier navigation and management. •   Keep your selections structured and easy for customers to browse. 13.   Products Management: •   Manage your inventory of products, including adding new items, updating existing ones, and managing stock levels. 14.   Barcode Generator: •   Create and manage barcodes for your products to streamline inventory management and revenue tracking. 15.   Services Management: •   Manage additional services offered by your restaurant, such as catering or event hosting. •   Keep track of service bookings and ensure smooth operations. 16.   Other Charges: •   Set up and manage additional charges such as service fees, delivery fees, or special event charges. •   Ensure that all applicable charges are accurately reflected in customer bills. 17.   Special Prices: •   Manage and apply special pricing for promotions, discounts, or loyalty programs. •   Offer competitive pricing to attract and retain customers. 18.   Subscribers Management: •   Manage your customer subscriber list for newsletters and promotions. 19.   eMarketing: •   Plan and execute email and SMS marketing campaigns. •   Use customer data to target specific audiences and drive more business to your restaurant. This section provides you with all the tools you need to efficiently manage your business’s operations, from staff and customers to selections and marketing, all in one place.',
        imenuBookInfo:
          'The iMenuBooks section is your comprehensive bookkeeping and financial management hub. This area allows you to seamlessly manage transactions, connect with bank accounts, and maintain a clear and accurate record of your financial activities. Here’s what you can do in the iMenuBooks section: 1.   Transaction Data: Manage and store all transaction data related to your business. This feature allows you to track every financial transaction, ensuring that your records are accurate and up to date. 2.   Bank Account Connection: Connect your business’s bank accounts directly to the iMenuBooks system. This feature enables automatic synchronization of financial data, making it easier to manage income, expenses, and account balances. 3.        View Transactions: View detailed records of all financial transactions processed through your business. This feature provides an organized and searchable view of your transaction history, allowing you to monitor and audit financial activities with ease.',
        reportsInfo:
          'The Reports section is your centralized hub for accessing and analyzing your business’s performance and financial data. This section provides you with various tools and reports to help you make informed decisions based on real-time data. Here’s what you can do in the Reports section: 1.   Payments: Track and review all payments made by customers. This feature provides a detailed breakdown of payment transactions, helping you monitor income and ensure accurate financial records. 2.   House Account: Manage and review house accounts used by your regular customers. This feature allows you to track account balances, charges, and payments, ensuring that your house accounts are always up to date. 3.   Revenue By Customers: Analyze revenue data segmented by individual customers. This report helps you identify key customers and understand their purchasing behaviors, allowing for targeted marketing and improved customer relationships. 4.   Revenue By Products: View revenue data based on specific products. This report enables you to identify your top-selling items and understand product performance, assisting in inventory management and product development decisions. 5.        Dynamic Report: Generate custom reports tailored to your specific business needs. This feature allows you to create dynamic reports by selecting various parameters, giving you the flexibility to analyze your data from multiple perspectives.',
        configInfo:
          'The Merchant Settings section allows you to configure various essential aspects of your business operations, ensuring that the platform aligns with your unique requirements and preferences.  This section includes the following key areas: 1.   General Settings: •   Business Information: Set up and update your business’s online presence, including name, address, contact details, social media links, and restaurant currency. •   Online Presence: Manage your website URL, location, and fax details. This is crucial for ensuring customers can find and contact you easily. •   Business Hours: Set and update your operating hours, ensuring your customers know when you’re available. •   Terms and Policies: Easily edit and manage your Terms of Use, Privacy Policy, and other relevant policies to ensure compliance and transparency with your customers. •  Catering and Delivery Settings: Define catering states, applicable zip codes, and types of catering events. Additionally, manage delivery zones and toggle features like delivery charges, geolocation viewing, and rating visibility. •  eCommerce & Online Sales: Control features like late fee invoices, asset pickup requests, and deposits, ensuring seamless online transactions and order management. 2.   Functionalities: Configure specific functionalities for catering orders and reservations, including table location preferences, customer reservation views, pre-payment options, and time-based settings. •   Invoice and Quote Settings: Configure starting numbers and prefixes for your invoices and quotes, helping you maintain an organized and professional billing system. •   Order Management: Set up and manage order prefixes, pick-up times, and other order-related configurations to streamline your order processing. •   Tips Configuration: Manage tip requirements, including setting default tip percentages, which is particularly useful in-service industries. •   Visibility Settings: Control whether certain information or features are visible to your customers, such as whether to show the cook or other businesses. 3.   Design Settings: •   Color Scheme: Customize the color scheme of your app, including primary, secondary, and tertiary colors, to align with your brand identity. Tailor the visual aspects of your platform by adjusting primary, secondary, and tertiary colors, customizing digital signage, and managing about us slides to present your business attractively. •   About Us Slides: Manage the slides that appear in your “About Us” section, allowing you to showcase your business’s unique offerings and personality. •   Digital Signage: Set up digital signage to display key information, selections, and advertisements within your app or at your physical location. 4.   Backup and Device Management: •   Device Management: Add and manage devices connected to your system, such as POS systems, printers, and more, ensuring everything is synced and functioning correctly. •   Backup Options: Create backups of your data and settings to ensure you have a fail-safe in case of any technical issues. You can download backups, restore from the portal, or restore from a file. Ensure data safety by making backups, restoring from files, and managing connected devices such as payment terminals. These settings allow you to tailor your iMenuApps® experience to your business needs, making it easier to manage operations and maintain a consistent brand presence across all customer touchpoints.',
        selections: 'Selections',
        productManagement: 'Products Managements'
      },
      controlPanel: {
        googleCalendar: 'Google Calendar',
        notificationCenter: 'Notification Center',
        notificationBell: 'Notification Bell',
        salesByCustomers: 'Sales By Customers',
        salesByProducts: 'Sales By Products',
        dynamicReport: 'Dynamic Report',
        events: "Create Events",
        eventTitle: "Events",
        transactionData: 'Add and edit finantial transactions',
        bankConnect: 'Add bank accounts and credit card accounts',
        viewTransaction: 'Add / Edit / View / your transactions',
        subscription:
          'View and Create Subscriptions and Billing (Virtual Terminal)',
        staff: 'Creation of user accounts for business workers.',
        occupations:
          'Management of business occupations. Occupations are related to staff members. Each member has a specific occupation.',
        roles:
          'Role management. The roles establish the permissions on the different areas of the application and are related to the staff members. A staff member can have multiple roles.',
        workSheet:
          'Work Sheet. Work sheet allow the control over staff working time.',
        customers: 'Displays a list of the business customers.',
        categories:
          'Manage the different categories of the menus. Categories are related to items. An item belongs to a category.',
        menuItems:
          'Management of items/products/services. A menu is made up of categories, and in turn, the items/products/services are related to the menu through the category to which it belongs.',
        services:
          'Management of services. The services are used in the catering menus.',
        menus:
          'Menu management. Allows menu management. A menu is made up of various categories.',
        orders: 'View and Create Orders. You can view and create orders here',
        invoices:
          'View and Create Invoices. You can view and create invoices here',
        quotes: 'View and Create Quotes. You can view and create quotes here',
        cateringOrders: 'Allows the display of catering orders.',
        orderForDelivery:
          'Displays a list of orders that are ready to be delivered to the driver who has been assigned the order.',
        tickets:
          'Allows the creation and tracking of tickets. Tickets are orders that remain open while the customer continues to consume.',
        otherCharges:
          'Allows the management of additional charges for quantity of products.',
        taxes: 'Tax management. View and create sales tax rates',
        deliveries:
          'Management of delivery prices. View and create price of delivery to charge customer',
        reservations: 'Manage and Create Reservations and Waitlists',
        tables:
          'Management of business capacities. View and create reservations based on capacity of the business',
        payments: 'Shows the list of payment transactions made.',
        aboutSettings:
          'It allows the management of the slider that appears on the home page of each business.',
        paymentSettings:
          'It allows the configuration of the payment gateway that will be used to process transactions.',
        basicSettings:
          'It allows the configuration of the main data of the business: Name, Address, Telephone... This information appears on the home page of each business.',
        funtionalitiesSettings:
          'It allows the configuration of the general operation of the business: Hours, Zip codes, tips...',
        colorSettings:
          'It allows the configuration of the colors of the application.',
        systemSettings:
          'Allows the configuration of iMenuApps® integration with third-party applications.',
        driver: 'Management of external drivers',
        credit: 'Allow credits administrations.'
      },
      options: {
        sameAsBilling: 'Same As',
        contactPerson: 'Contact Person',
        email: 'Email',
        aditionalDetails: 'Additional details',
        street: 'Street',
        text: 'There was a problem setting the default address.',
        updateAddress: 'Updated address',
        wrongAddress: 'Something went wrong while trying to update the default address',
        billingAddress: 'Billing Address',
        shippingAddress: 'Shipping Address',
        placeholderNotes: 'Write your notes here',
        dataRequired: 'Data Required',
        customerArea: 'Customer Area',
        customerName: 'Customer Name',
        customerEmail: 'Customer Email',
        customerPhone: 'Customer Phone',
        customerAddress: 'Customer Address',
        terms: 'Terms',
        trackingN: 'Tracking N°',
        shippingDate: 'Shipping Date',
        shippingTo: 'Shipping To',
        footer: 'Edit the respective Footer for your Revenue Module',
        ivoiceDate: 'Invoice Date',
        quoteDate: 'Quote Date',
        subscriptionBilling: 'Subscription Billing',
        driverDeliveries: 'Deliveries',
        activeDriverOrder: 'Active Orders',
        completedDriverOrder: 'Completed Orders',
        useDirection: 'Click if same as billing address',
        menuTitle: 'ADMIN',
        login: 'Login',
        logout: 'Logout',
        controlPanel: 'Control Panel',
        adminSettings: 'Admin Settings',
        supportPanel: 'Support',
        manageMenus: 'Menus',
        managePyments: 'Payments',
        manageHouseAccount: 'House Account',
        viewOrders: 'View/Create Orders',
        viewQuotes: 'Quotes',
        viewInvoice: 'Invoices',
        manageCategories: 'Categories',
        manageProducts: 'Items',
        manageServices: 'Services',
        manageCustomers: 'Customers',
        manageCredits: 'Credits',
        manageTables: 'Tables',
        manageTaxes: 'Taxes',
        manageShippings: 'Deliveries',
        manageOtherCharges: 'Other Charges',
        manageUsers: 'Staff',
        manageDriver: 'Drivers',
        manageRoles: 'Roles/Permissions',
        manageWorkSheet: 'Worksheet',
        manageBasicSettings: 'Business',
        manageRestaurantSettings: 'Business Settings',
        manageAboutSettings: 'About Us Slides',
        manageFunSettings: 'Functionalities',
        manageColourSettings: 'Colours',
        manageDesign: 'Design',
        manageMore: 'More',
        managePaymentSettings: 'Payments',
        manageOccupation: 'Occupations',
        manageKeySettings: 'External Systems',
        supportSettings: 'Support Settings',
        changeServerId: 'Change Employee ID',
        serverId: 'Employee Code',
        manageVariantGroup: 'Choices',
        manageReservation: 'Reservations',
        manageWaitList: 'Wait List',
        viewCateringOrders: 'Catering Orders',
        forgotPassword: 'Did you forget your password?',
        sendNewPassword: 'Send a new password',
        serverIdMessage:
          'This is the security code assigned to you when your profile was created',
        recoveryPassword: 'Recovery password',
        refund: 'Refund',
        void: 'Void'
      },
      titles: {
        technology: "Technology",
        retail: "Retail",
        healthcare: "Healthcare",
        finance: "Finance",
        retailGeneralMerchandise: "Retail (General Merchandise)",
        healthcareServices: "Healthcare Services",
        foodAndBeverage: "Food and Beverage (Restaurants, Cafes, Bars)",
        construction: "Construction",
        eCommerce: "E-Commerce",
        informationTechnology: "Information Technology (IT Services and Software Development)",
        realEstate: "Real Estate (Residential and Commercial)",
        transportationLogistics: "Transportation and Logistics",
        professionalServices: "Professional Services (Consulting, Legal, Accounting)",
        manufacturing: "Manufacturing (General and Specialized)",
        educationTraining: "Education and Training Services",
        entertainmentMedia: "Entertainment and Media",
        financialServices: "Financial Services (Banks, Investment Firms)",
        personalCareServices: "Personal Care Services (Salons, Spas)",
        hospitality: "Hospitality (Hotels, Travel Agencies)",
        insuranceAgencies: "Insurance Agencies",
        homeImprovementRepair: "Home Improvement and Repair",
        automotiveServices: "Automotive Services (Repair, Dealerships, Body Shops)",
        telecommunications: "Telecommunications",
        nonprofitSocialServices: "Nonprofit and Social Services",
        agricultureFarming: "Agriculture and Farming",
        pharmaceuticalsBiotechnology: "Pharmaceuticals and Biotechnology",
        energy: "Energy (Renewable and Non-Renewable)",
        sportsRecreation: "Sports and Recreation",
        fitnessWellness: "Fitness and Wellness",
        marketingAdvertising: "Marketing and Advertising",
        eventPlanning: "Event Planning and Services",
        cleaningServices: "Cleaning Services (Residential and Commercial)",
        fashionApparel: "Fashion and Apparel",
        foodProductionProcessing: "Food Production and Processing",
        petServices: "Pet Services (Grooming, Boarding, Veterinary)",
        artsCrafts: "Arts and Crafts (Creative Services)",
        aerospaceDefense: "Aerospace and Defense",
        environmentalServices: "Environmental Services",
        technologyHardwareElectronics: "Technology Hardware and Electronics",
        childcareServices: "Childcare Services",
        securityServices: "Security Services (Cybersecurity, Physical Security)",
        publishing: "Publishing (Books, Magazines, Digital Media)",
        transportationEquipmentManufacturing: "Transportation Equipment Manufacturing",
        architectureDesign: "Architecture and Design",
        accountingTaxPreparation: "Accounting and Tax Preparation",
        landscapingGardening: "Landscaping and Gardening",
        beverageProduction: "Beverage Production (Craft Beer, Wine, Spirits)",
        medicalDevicesSupplies: "Medical Devices and Supplies",
        warehousingStorage: "Warehousing and Storage",
        freelancing: "Freelancing (Writing, Graphic Design, Programming)",
        tourismAdventureServices: "Tourism and Adventure Services",
        utilitiesPublicServices: "Utilities and Public Services",
        blockchainCryptocurrency: "Blockchain and Cryptocurrency",
        specializedRetail: "Specialized Retail (Niche Products and Services)",
        eventPlanningServices: "Event Planning and Services",
        transportationEquipment: "Transportation Equipment Manufacturing",
        accountingTax: "Accounting and Tax Preparation",
        tourismAdventure: "Tourism and Adventure Services",
        shareViaEmailAndSMS: 'Share via Email & SMS',
        sendEmail: 'Send Email',
        sendSMS: 'Send SMS',
        send: "Send",
        sendNow: 'Send Now',
        schedule: 'Schedule',
        cancel: 'Cancel',
        selectMethod: 'Please select at least one method (Email or SMS)',
        emailCheck: 'Please enter an email or uncheck the Email option.',
        smsCheck: 'Please enter a phone number or uncheck the SMS option.',
        searchCustomer: 'Search for client or subscriber',
        emailPlaceholder: 'Email',
        phonePlaceholder: 'Phone Number',
        sendByEmailAndSMS: 'Send by Email & SMS',
        textSend: 'You may add several email addresses by adding a comma after each one',
        sendNotification: 'You are about to send this notification to:',
        whenToSend: 'When do you want to send it?',
        bankAccountName: 'Bank account name',
        routeNumber: 'Route number',
        accountNumber: 'Account number',
        bankAccountAddress: 'Bank account address',
        nameAuthorizedPerson: 'Name of authorized person',
        paymentAmount: 'Payment amount',
        mustBe: 'Must be 9 digits',
        warning: 'Warning',
        messageChangeQuote:
          'If you change this Prefix again, your sequence numbering of your quotes will change',
        messageChangeIvoice:
          'If you change this Prefix again, your sequence numbering of your invoices will change',
        messageStartingInvoiceNumber:
          'If you will change this starting number, your numbering for the invoices will be reset to start from this number.',
        prefixQuotes: 'Prefix for Quotes (e.g. QTE)',
        prefixInvoices: 'Prefix for Invoices (e.g. INV)',
        invoiceStartingNumber: 'Invoice Starting Number',
        moneyNotEnought: 'Amount must be greater than the total to get change',
        controlPanel: 'Control Panel',
        supportPanel: 'Support',
        menus: 'Menus',
        orders: 'Orders',
        quotes: 'Quotes',
        invoices: 'Invoices',
        allOrders: 'All Orders',
        customerCredit: 'Customer Credit',
        workSheet: 'Work Sheet',
        cateringOrders: 'Catering Orders',
        ordersForDelivery: 'Orders for Delivery',
        suscriptors: 'Subscribers',
        tickets: 'Order Tickets',
        categories: 'Categories',
        products: 'Items',
        customers: 'Customers',
        tables: 'Tables',
        taxes: 'Taxes',
        shippings: 'Delivery Prices',
        otherCharges: 'Other Charges',
        newsletter: 'Newsletter',
        users: 'Staff',
        suscriptor: 'Subscribers',
        createCustomer:"Create Customer",
        communicationResponse: 'Communication Response',
        smsResposes: "SMS Responses",
        emailResponses: "Email Responses",
        loadingEmailResponses: "Loading email responses...",
        loadingSmsResponses: "Loading SMS responses...",
        perPage: "Per Page",
        emailNoSent: "Email no sent",
        noEmailResponses: "No Email Responses",
        noEmailFound: "No email responses found for your account",
        noSmsResponses: "No SMS Responses",
        noSmsFound: "No SMS responses found for your account",
        createSubscriptor: "Create Subscriptor",
        occupation: 'Occupation',
        roles: 'Roles',
        about: 'About Us Slides',
        digitalScreens: 'Digital screens',
        editAboutForm: 'Edit About Us Slide',
        newAboutForm: 'Create a New About Us Slide',
        editDisplayForm: 'Edit Digital Signage Slide',
        newDisplayForm: 'Create a Digital Signage Slide',
        basicConfig: 'Basic Conf.',
        functions: 'Functionalities',
        colors: 'Colors',
        variantGroup: 'Choices',
        loading: 'Please wait...',
        editColorSetting: 'Edit Color',
        createColorSetting: 'Create Color ',
        orderCateringForm: 'Edit Catering Order',
        deliveryLocation: 'Delivery location',
        cateringMenus: 'Catering Menus',
        payments: 'Payments',
        ticketDetails: 'Ticket Details',
        emptyResult: 'Empty result',
        cancellationType: 'Cancellation type',
        changePassword: 'Change password',
        restaurantName: 'Business name',
        clockinClockout: 'Clock In - Clock Out',
        clockin: 'Clock In',
        clockout: 'Clock Out',
        timecard: 'Timecard',
        timesheet: 'Timesheet',
        addContact: 'Add Contact',
        updateContact: 'Update Contact',
        contacts: 'Contacts',
        staff: 'Staff'
      },
      placeholder: {
        contactNotFound: 'Contact Not found'
      },
      orderState: {
        started: 'started',
        inKitchen: 'in kitchen',
        cooked: 'cooked',
        delivering: 'pending delivery',
        delivered: 'delivered'
      },
      list: {
        buttons: {
          goToControlPanel: 'Go to management'
        },
        actions: {
          addANew: 'Add a new',
          edit: 'Edit',
          delete: 'Delete',
          view: 'View'
        },
        entitiesName: {
          menu: 'menu',
          category: 'category',
          categoryPlaceholder: 'Select category',
          product: 'item',
          customer: 'customer',
          table: 'table',
          tax: 'tax',
          taxPlaceholder: 'Select tax',
          shipping: 'delivery',
          otherCharge: 'other charge',
          user: 'user',
          order: 'order',
          role: 'role',
          about: 'about'
        },
        messages: {
          confirmDelete: 'Confirm delete',
          confirmAccept: 'Confirm item',
          confirmProduct: 'Do you want to accept this item?',
          deleteCategory: 'Do you want to delete this category?',
          deleteRestaurant: 'Do you want to delete this business?',
          deleteOrder: 'Do you want to delete this order?',
          deleteCredit: 'Do you want to delete this credit?',
          deleteWorkSheet: 'Do you want to delete this work sheet?',
          deleteCustomer: 'Do you want to delete this customer?',
          deleteMenu: 'Do you want to delete this menu?',
          deleteOtherCharge: 'Do you want to delete this other charge?',
          deleteNewsletter: 'Do you want to delete this newsletter?',
          deleteProduct: 'Do you want to delete this item?',
          deleteShipping: 'Do you want to delete this delivery?',
          deleteTable: 'Do you want to delete this table?',
          deleteTax: 'Do you want to delete this tax?',
          deleteUser: 'Do you want to delete this user?',
          deleteSuscriptor: 'Do you want to delete this subscriber?',
          deleteRole: 'Do you want to delete this role?',
          deleteAbout: 'Do you want to delete this information?',
          deleteDisplay: 'Do you want to remove this ad?',
          deleteOccupation: 'Do you want to delete this occupation?',
          deleteVariantGroup: 'Do you want to delete this choices?',
          infoDeleteSuccess: 'Info',
          invalidCode: 'Invalid code, please try again.',
          messageDeleteSuccessCategory: 'Category was successfully deleted',
          messageDeleteSuccessRestaurant: 'Business was successfully deleted',
          messageDeleteSuccessOrder: 'Order was successfully deleted',
          messageDeleteSuccessCredit: 'Credit was successfully deleted',
          messageDeleteSuccessWorkSheet: 'Work sheet was successfully deleted',
          messageDeleteSuccessCustomer: 'Customer was successfully deleted',
          messageDeleteSuccessMenu: 'Menu was successfully deleted',
          messageDeleteSuccessOtherCharges:
            'Other charges was successfully deleted',
          messageDeleteSuccessNewsletter: 'Newsletter was successfully deleted',
          messageDeleteSuccessProduct: 'Item was successfully deleted',
          messageDeleteSuccessShipping: 'Shipping was successfully deleted',
          messageDeleteSuccessTable: 'Table was successfully deleted',
          messageDeleteSuccessTax: 'Tax was successfully deleted',
          messageDeleteSuccessUser: 'User was successfully deleted',
          messageDeleteSuccessSuscriptor: 'Subscriber was successfully deleted',

          messageActivareSuccessSuscriptor:
            'Subscriber was successfully activated',
          messageDesactivareSuccessSuscriptor:
            'Subscriber was successfully deactivated',

          messageDeleteSuccessRole: 'Role was successfully deleted',
          messageDeleteSuccessAbout: 'Information was successfully deleted',
          messageDeleteSuccessOccupation: 'Occupation was successfully deleted',
          messageDeleteSuccessVariantGroup: 'Choices was successfully deleted',
          messageCateringApproved:
            'The catering order was successfully approved',
          messageCateringCancelled:
            'The catering order was successfully canceled',
          titleEditCategory: 'Edit category',
          titleEditCustomer: 'Edit customer',
          titleEditMenu: 'Edit menu',
          titleEditOtherCharges: 'Edit other charge',
          titleEditProduct: 'Edit item',
          titleEditShipping: 'Edit delivery',
          titleEditTable: 'Edit table',
          titleEditTax: 'Edit tax',
          titleEditUser: 'Edit user',
          titleEditRole: 'Edit role',
          titleEditSetting: 'Edit setting',
          titleEditOccupation: 'Edit occupation',
          titleCreateCategory: 'Create category',
          titleCreateCustomer: 'Create customer',
          titleCreateMenu: 'Create menu',
          titleCreateOtherCharges: 'Create other charge',
          titleCreateProduct: 'Create item',
          titleCreateShipping: 'Create delivery',
          titleCreateTable: 'Create table',
          titleCreateTax: 'Create tax',
          titleCreateUser: 'Create user',
          titleCreateRole: 'Create role',
          titleCreateSetting: 'Create setting',
          titleCreateOccupation: 'Create occupation',
          titleEditVariantGroup: 'Edit choices',
          titleCreateVariantGroup: 'Create a new choices',
          messageEditSuccessCategory: 'The category was edited successfully',
          messageEditSuccessCredit: 'The credit was edited successfully',
          messageEditSuccessCustomer: 'The customer was edited successfully',
          messageEditSuccessMenu: 'The menu was edited successfully',
          messageEditSuccessWorksheet: 'The worksheet was edited successfully',
          messageEditSuccessOtherCharges:
            'The other charge was edited successfully',
          messageEditSuccessProduct: 'The item was edited successfully',
          messageEditSuccessShipping: 'The delivery was edited successfully',
          messageEditSuccessTable: 'The table was edited successfully',
          messageEditSuccessTax: 'The tax was edited successfully',
          messageEditSuccessUser: 'The user was edited successfully',

          messageEditSuccessSuscriptor:
            'The subscriber was edited successfully',
          messageEditSuccesRole: 'The role was edited successfully',
          messageEditSuccessSetting: 'The settings was edited successfully',
          messageEditSuccessOccupation:
            'The occupation was edited successfully',
          messageEditSuccessVariantGroup: 'The choices was edited successfully',
          messageDeleteSuccessVariant: 'The choices was deleted successfully',
          messageEditSuccessVariant: 'The choices was edited successfully',
          messageCreateSuccessVariant: 'The choices was created successfully',
          messageCreateSuccessCategory: 'The category was created successfully',
          messageCreateSuccessCredit: 'The credit was created successfully',
          messageCreateSuccessCustomer: 'The customer was created successfully',
          messageCreateSuccessMenu: 'The menu was created successfully',
          messageCreateSuccessWorksheet:
            'The worksheet was created successfully',
          messageCreateSuccessOtherCharges:
            'The other charge was created successfully',
          messageCreateSuccessProduct: 'The item was created successfully',
          messageCreateSuccessShipping: 'The delivery was created successfully',
          messageCreateSuccessTable: 'The table was created successfully',
          messageCreateSuccessTax: 'The tax was created successfully',
          messageCreateSuccessUser: 'The user was created successfully',
          messageCreateSuccessSuscriptor:
            'The subscriber was created successfully',
          messageCreateSuccessRole: 'The role was created successfully',
          messageCreateSuccessSetting: 'The setting was created successfully',
          messageCreateSuccessOccupation:
            'The occupation was created successfully',
          messageCreateSuccessVariantGroup:
            'The choices was created successfully',
          menuChangeState: 'Menu state was successfully changed',
          activeMenu: 'Active menu',
          otherChargeChangeState: 'Other charge state was successfully changed',
          activeOtherCharge: 'Active other charge',
          taxChangeState: 'Tax state was successfully changed',
          activeTax: 'Active tax',
          shippingChangeState: 'Shipping state was successfully change',
          activeShipping: 'Active delivery',
          deleteSubtitleCategory: 'Delete category',
          deleteSubtitleCustomer: 'Delete customer',
          deleteSubtitleMenu: 'Delete menu',
          deleteSubtitleOtherCharges: 'Delete other charges',
          deleteSubtitleProduct: 'Delete item',
          deleteSubtitleShipping: 'Delete delivery',
          deleteSubtitleTable: 'Delete table',
          deleteSubtitleTax: 'Delete tax',
          deleteSubtitleUser: 'Delete user',
          deleteSubtitleRole: 'Delete role',
          deleteSubtitleAbout: 'Delete information',
          deleteSubtitleOccupation: 'Delete occupation',
          deleteSubtitleVariantGroup: 'Delete choices',
          deleteAertMessage: 'Are you sure you want to delete the contact.',
          errorTitle: 'Error',
          errorMessage: 'Something went wrong.',
          changeOrderStateMessage: 'Change order state',
          changeOrderStateSuccess: 'Order state was changed successfully',
          changeOrderStateCanceled: 'Order was canceled',
          connectionError: 'Connection error',
          sharedWorksheet: 'Shared worksheet with the Staff member',
          connectionErrorMessage:
            'There was an error connection. Please, verify your internet connection and retry. If the problem persist, contact your service provider.',
          newPasswordSent: 'The new password was sent to your email',
          emailOrPasswordIncorrect: 'Email or password incorrect',
          buttons: {
            cancel: 'Cancel',
            delete: 'Delete',
            close: 'Close',
            goToAdministration: 'Go to administration',
            goToList: 'Go to list',
            retry: 'Retry'
          }
        }
      },
      form: {
        includeMiddleName: 'Include middle name and last name',
        login: 'Login',
        events: {
          backgroundImage: 'Background Image',
          backgroundColor: 'Background Color',
          backgroundColorSection: 'Add background color to this section',
          backgroundColorDates: 'Background color for dates',
          backgroundColorTitle: 'Background color for the title',
          backgroundColorSubtitle: 'Background color for the subtitle',
          backgroundColorDescription: 'Background color for the description',
          backgroundColorFooter: 'Background color for the footer',
          startDate: 'Start Date',
          endDate: 'End Date',
          startTime: 'Start Time',
          endTime: 'End Time',
          dates: 'Dates',
          title: 'Title',
          subtitle: 'Subtitle',
          description: 'Description',
          footer: 'Footer',
          saveToCalendar: 'Add to Google Calendar'
        },
        colour: {
          primaryColor: 'Primary color',
          primary: 'Primary',
          primaryText: 'Primary text',
          secondaryColor: 'Secondary color',
          secondary: 'Secondary',
          secondaryText: 'Secondary text',
          tertiaryColor: 'Tertiary color',
          tertiary: 'Tertiary',
          tertiaryText: 'Tertiary text',
          successColor: 'Success color',
          success: 'Success',
          successText: 'Success text',
          dangerColor: 'Danger color',
          danger: 'Danger',
          dangerText: 'Danger text',
          backgroundColor: 'Background color',
          background: 'Background'
        },
        tableShape: {
          square: 'Square',
          rectangular: 'Rectangular',
          circle: 'Circle',
          oval: 'Oval'
        },
        buttons: {
          backToCategoriesList: 'Back to categories list',
          backToCustomersList: 'Back to customers list',
          backToMenusList: 'Back to menus list',
          backToOrdersList: 'Back to orders list',
          backToOtherChargesList: 'Back to others charges list',
          backToProductsList: 'Back to item list',
          backToShippingsList: 'Back to deliveries list',
          backToTablesList: 'Back to tables list',
          backToTaxesList: 'Back to taxes list',
          backToUsersList: 'Back to users list',
          backToRolesList: 'Back to roles list',
          backToAboutList: 'Back to about list',
          backToMenu: 'Back to menu',
          cancelOrder: 'Cancel order',
          changeState: 'Change state to',
          defaultColor: 'Default ',
          addChoice: 'Add Variant',
          back: 'Back',
          save: 'Save',
          submit: 'Submit',
          change: 'Change',
          add: 'Add',
          update: 'Update'
        },
        titles: {
          identificationInformation: 'Identification Information',
          idType: 'ID Type',
          driverLicense: "Driver's License",
          internationalId: 'International ID (Cedula)',
          nameLicense: 'Name on License',
          licenseNumber: 'License Number',
          issueDate: 'Issue Date',
          expirationDate: 'Expiration Date',
          sex: 'Sex',
          dateBirth: 'Date of Birth',
          meters: "Meters",
          feet: "Feet",
          centimeters: "Centimeters",
          inches: "Inches",
          height: 'Height',
          nameId: 'Name on ID',
          identificationNumber: 'Identification Number',
          nationality: 'Nationality',
          martialStatus: 'Marital Status',
          single: 'Single',
          married: 'Married',
          divorced: 'Divorced',
          widowed: 'Widowed',
          occupation: 'Occupation',
          socialeMediaChannels: 'Social Media Channels',
          customerType: 'Customer Type',
          customerStatus: 'Customer Status',
          gender: 'Gender',
          preferredContact: 'Preferred Contact Method',
          enableAll: 'Enable All',
          disableAll: 'Disable All',
          invoiceReminderLabel:
            'Enter every how many days a reminder will be sent',
          invoiceReminder: 'Turn-On Invoice Reminders',
          assetPickupRequest: 'Asset Pickup Request',
          pickupAddress: 'Pickup Address',
          requireDeposit: 'Require Deposit',
          lateFees: 'Turn-On Late Fees Invoice',
          lateFeesLabel: 'Enter the percentage of arrears to collect',
          thisInvoice: 'This Invoice has been PAID',
          customerNewTitle: 'Create a new customer',
          customerEditTitle: 'Edit customer',
          categoryNewTitle: 'Create a new category',
          creditNewTitle: 'Create a new credit',
          categoryEditTitle: 'Edit category',
          creditEditTitle: 'Edit credit',
          menuNewTitle: 'Create a new menu',
          workSheetNewTitle: 'Create Worksheet',
          menuEditTitle: 'Edit menu',
          workSheetEditTitle: 'Edit Worksheet',
          productNewTitle: 'Create an item',
          serviceNewTitle: 'Create a service',
          productEditTitle: 'Edit item',
          serviceEditTitle: 'Edit service',
          changePaymentSetting: 'Change payment settings',
          shippingNewTitle: 'Create a new delivery price',
          shippingEditTitle: 'Edit delivery price',
          taxNewTitle: 'Create a new tax',
          taxEditTitle: 'Edit tax',
          tableNewTitle: 'Create a new table',
          tableEditTitle: 'Edit table',
          packageNewTitle: 'Create a new package',
          packageEditTitleditTitle: 'Edit package',
          variantGroupEditTitle: 'Edit choices',
          variantGroupNewTitle: 'Create a new choice',
          otherChargeNewTitle: 'Create a new other charge',
          otherChargeEditTitle: 'Edit other charge',
          userNewTitle: 'Create a new staff member',

          suscriptionNewTitle: 'Create a new subscription',

          driversNewTitle: 'Create a new driver',
          userEditTitle: 'Edit staff member',

          suscriptionEditTitle: 'Edit subscription',
          driversEditTitle: 'Edit driver',
          supportUsers: 'Support users',
          occupationNewTitle: 'Create New Occupation/Job',
          occupationEditTitle: 'Edit Occupation/Job',
          roleNewTitle: 'Add Permissions',
          roleEditTitle: 'Edit role',
          selectAProduct: 'Select a item',
          selectACategory: 'Select a category',
          selectACustomer: 'Select a customer',
          selectATax: 'Select a tax',
          selectARestaurant: 'Select a business',
          selectAState: 'Select a state',
          filterCategory: 'Filter...',
          selectALanguage: 'Language',
          selectAnOccupation: 'Select an occupation',
          selectACooker: 'Select a cook',
          selectADriver: 'Select a driver',
          allProducts: 'All items:',
          settingEditTitle: 'Edit settings',
          settingNewTitle: 'Add settings',
          generalSettingEditTitle: 'Edit basic settings',
          generalSettingNewTitle: 'Add basic settings',
          keySettingEditTitle: 'Edit system settings',
          keySettingNewTitle: 'Create system settings',
          funSettingEditTitle: 'Functionalities Settings',
          funSettingNewTitle: 'Create functionalities settings',
          pickFromSelect: 'Select pick from',
          pickToSelect: 'Select pick to',
          dateFromSelect: 'Select date from',
          dateToSelect: 'Select date to',
          cancelOrder: 'Cancel order',
          drivers: 'Drivers',
          customer: 'Customer',
          date: 'Date',
          startDate: 'Start Date',
          endDate: 'End Date',
          orderType: 'Order type',
          addressToDelivery: 'Address for delivery',
          hourToPick: 'Hour to pick-up',
          tableService: 'Table service',
          products: 'Items',
          services: 'Services',
          otherCharges: 'Other charges',
          shippingPrice: 'Shipping price',
          subtotal: 'Subtotal',
          tax: 'Tax total',
          tip: 'Tip',
          total: 'Total',
          number: 'Number',
          doYou: 'Do you really want to delete',
          marked: 'marked records?',
          pendingPay: 'Pending Payment',
          payed: 'Paid',
          notes: 'Notes',
          cancelNotes: 'Cancel notes',
          pickupNotes: 'Pickup Notes',
          cooker: 'Cook',
          state: 'State',
          generalConfiguration: 'GENERALS CONFIGURATIONS',
          paymentConfiguration: 'PAYMENT CONFIGURATIONS',
          cashDiscount: 'CASH DISCOUNT',
          eposConfiguration: 'EPOS CONFIGURATION',
          emailConfiguration: 'EMAIL CONFIGURATIONS',
          twilioSMS: 'Twilio SMS',
          sinchSMS: 'Sinch SMS',
          selectAVariantGroup: 'Select a choice',
          imageText:
            'For better results please upload image size 750x750px. Make certain that you have rights to any image uploaded',
          orderCateringForm: 'Approval of catering order',
          restaurantHours: 'Business hours',
          deadlinesNotes:
            'Please, ensure that the sum of the deadlines is 100.',
          selectDate: 'Select date',
          toPay: 'To pay',
          pending: 'Pending',
          genaral: 'General',
          others: 'Others',
          variants: 'Variants',
          sides: 'Sides',
          ingredients: 'Ingredients',
          shift4: 'Shift4',
          auth: 'Authorize.Net',
          capcha: 'Captcha',
          zipCodes: 'Zip codes',
          backups: 'Backups',
          devices: 'Devices',
          creditSetting: 'Credit Setting'
        },
        fields: {
          createNewCustomer: 'Create New Customer',
          editItem: 'Edit Item',
          previewInvoice: 'Preview Invoice',
          companyName: 'Company Name',
          companyEmail: 'Company Email',
          companyPhone: 'Company Phone',
          companyTitle: 'Job Title',
          companyWebSite: 'Company Web Site',
          companyIndustry: 'Company Industry',
          addNewCustomer: 'Add New Customer',
          projectName: 'Project Name',
          billingAddress: 'Billing Address',
          selectCustomerAttachBillingAddress: 'Select a customer to attach a billing address',
          selectCustomerAttachShippingAddress: 'Select a customer to attach a shipping address',
          selectedAddress: 'Selected Address:',
          changeAddress: 'Change a',  
          addAddress: 'Add a',
          number: 'Number',
          shippingAddress: 'Shipping Address',
          username: 'Username',
          emailLabel: 'Email',
          phoneLabel: 'Phone',
          firstNameLabel: 'First Name',
          lastNameLabel: 'Last Name',
          putEmail: 'Enter your email',
          putPhone: 'Enter your phone',
          putFirstName: 'Enter your first name',
          putLastName: 'Enter your last name',
          putUserName: 'Enter your username',
          takePicture: 'Take Picture',
          accept: 'Accept',
          hidde: 'Hidde',
          delete: 'Delete',
          retake: 'Retake',
          previewPhoto: 'Preview Photo',
          previewAcceptedPhoto: 'Preview Accepted Photo',
          viewImenuBookControlPanel: 'View iMenuBooks on Control Panel',
          viewImenuEngageControlPanel: 'View iMenuEngage360 on Control Panel',
          viewImenuBookOptions: 'View iMenuBooks Options',
          viewOrdersOption: 'View Order Option',
          viewReservationOption: 'View Reservation Option',
          viewInvoiceOption: 'View Invoice Option',
          viewQuoteOption: 'View Quote Option',
          changeImage: 'Change Image',
          addImage: 'Add Image',
          customerHours: 'Customer Hours',
          to: 'To',
          subject: 'Subject',
          message: 'Message',
          name: 'Name',
          menuName: 'Menu name',
          description: 'Description',
          email: 'Email',
          password: 'Password',
          date: 'Date',
          image: 'Image',
          phone: 'Phone',
          productMin: 'Item min',
          productMax: 'Item max',
          price: 'Price',
          extraCharge: 'Extra Charge',
          costPrice: 'Cost',
          retailPrice: 'Sale',
          stimateTime: 'Estimated time (in minutes)',
          stockQuantity: 'Stock Quantity',
          minReorderPoint: 'Lower Stock Quantity',
          maxReorderPoint: 'Max Stock Quantity',
          CreditAmount: 'Credit Amount',
          vendorName: 'Vendor Name',
          vendorCode: 'Vendor Code',
          shortDescription: 'Short Description',
          keywords: 'Keywords',
          tags: 'Tags',
          binNumber: 'Bin Number',
          addSerialNumber: 'Add Serial Number',
          active: 'Activate',
          save: 'Save',
          submitToken: 'Submit Token',
          available: 'Available',
          availableCategories: 'AVAILABLE CATEGORIES',
          availableProducts: 'AVAILABLE ITEMS',
          availableStaff: 'AVAILABLE STAFF',
          selectedProducts: 'SELECTED ITEMS',
          selectedCategories: 'SELECTED CATEGORIES',
          selectedStaff: 'SELECTED STAFF',
          workedHours: 'WORKED HOURS',
          scheduledDates: 'Scheduled Dates',
          selectedAggregates: 'SELECTED AGGREGATES',
          marketingConsent: 'MARKETING CONSENT',
          product: 'Item',
          category: 'Category',
          tax: 'Tax',
          parentCategory: 'Parent category',
          qrCode: 'QR Code',
          capacity: 'Capacity',
          percent: 'Percentage',
          priority: 'Priority (0 - 1)',
          permissions: 'Permissions',
          permissionsRole: 'Permission Roles',
          selectCashDiscount: 'Select Cash Discount',
          roles: 'Occupation/Job',
          address: 'Address',
          title: 'Title',
          subtitle: 'Subtitle',
          online: 'Online',
          showOtherRestaurant: 'Show others business',
          reservationByTable: 'Book a table',
          reservationByStaff: 'Book staff',
          tablesChoose: 'Client can choose location of table',
          onlineMss: 'Business is not visible to the public ',
          onlineMss1: 'Business is visible to the public ',
          mustClockinMss: 'You must clock-in first. Please, ',
          mustClockin2Mss: 'clock in.',
          SelectPickHour: 'Select pick-up hour',
          SelectPickHour2: 'Activate Pick-Up Time',
          TipRequire: 'Require a Tip',
          tips: 'Tips',
          assetPickup: 'Asset Pickup',
          depositAmount: 'Deposit Amount',
          typeTip: 'Type a percent tip',
          MinTimeToCook: 'Min time to cook',
          PickFrom: 'Pick-up starting at',
          PickFromToolTip: 'Add the time delivery starts',
          PickTo: 'End of pick-up time',
          PickToToolTip: 'Add the time delivery ends',
          DateFrom: 'Date from',
          DateTo: 'Date to',
          DateLimit: 'Limit date to pay',
          ShowCooker: 'Show cook',
          zipCodes: 'Zip codes',
          deliveryZone: 'Delivery zones',
          cooker: 'Cook',
          driver: 'Driver',
          rejectedOrder: 'Order Rejected By Driver',
          cancelationNote: 'Cancellation note',
          tableNumber: 'Table number',
          firstName: 'First name',
          lastName: 'Last name',
          occupation: 'Occupation',
          confirmPassword: 'Confirm password',
          endPointUrl: 'Endpoint Url',
          capchaKey: 'Captcha key',
          clientGuid: 'Client GUID',
          interfazVersion: 'Interface version',
          interfazName: 'Interface name',
          apiLoginId: 'API login Id',
          eposToken: 'ePos token',
          epos: 'Integrate with ePos',
          transactionKey: 'Transaction Key',
          smtpHost: 'SMTP Host',
          port: 'Port',
          secure: 'Secure',
          twFromNumber: 'From number',
          twAccountSID: 'Account SID',
          twToken: 'Token',
          sinchFromNumber: 'From number',
          sinchAccountSID: 'Service plan id',
          sinchToken: 'Token',
          web: 'Website',
          variantGroup: 'Choices',
          haveSides: 'Sides',
          cantOfSides: 'Number of sides included',
          categoryOfSides: 'Filter sides for category',
          addIngredients: 'Specify ingredients',
          typeAnIngredient: 'Type an ingredient',
          canViewGeoposition: 'Can view Geolocation',
          canViewRating: 'Can view rating',
          viewDelivery: 'Can create delivery orders',
          viewOnTable: 'Can create table orders',
          viewCurbside: 'Can create curbside orders',
          tablePrefix: 'Table prefix',
          barPrefix: 'Bar prefix',
          roomPrefix: 'Room prefix',
          typeZipCode: 'Enter a zipCode',
          isCatering: 'Is catering',
          isService: 'Service menu',
          isReservationMenu: 'Reservation menu',
          catering: 'Catering',
          minAmoutCatering: 'Min amount for catering',
          minAmountCateringDelivery: 'Min amount for delivery',
          loyaltyMinPointToBuy: 'Min points to buy',
          loyaltyExpirationMonths: 'Loyalty expiration number of months',
          loyaltyPointMoney: 'Number of points for $1',
          partialPay: 'Partial pay',
          payForQuotation: 'Pre-pay for quotation',
          percentPayForQuotation: 'Pre-payment amount for quotation',
          service: 'Service',
          showServicePrice: 'Show service price',
          viewCatering: 'View catering',
          viewLoyalty: 'View loyalty program',
          viewReservation: 'View reservation',
          reservation: 'Reservation',
          loyalty: 'Loyalty Program',
          minDayToReservation: 'Minimum number of days to reserve',
          viewCustomerReservation: 'View customers reservation',
          sameHourForAllDays: 'Same hour for all days',
          followingDays: 'Same hours for the following days',
          timezone: 'Timezone',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
          allDays: 'All days',
          marginDays: 'Minimum number of days to place order',
          cateringStates: 'Catering states',
          typeState: 'Enter a state code',
          zipCodesExclude: 'Zip Codes included',
          cateringEvents: 'Catering event',
          typeEventName: 'Enter an event name',
          proposeNewDataTime: 'Propose a new date/time',
          fixed: 'Fixed amount',
          amount: 'Amount',
          discount: 'Discount',
          deadlines: 'Deadlines',
          pendingPay: 'Pending payment',
          payed: 'Paid',
          states: 'States',
          paymentMethod: 'Payment Method',
          cash: 'Cash',
          card: 'Card',
          check: 'Check',
          free: 'Free',
          busy: 'Busy',
          dirty: 'Dirty',
          authenticationToken: 'Authorization token',
          authenticationTokenMoto: 'MOTO Authorization token',
          authenticationTokenFB: 'F&B Authorization token',
          accountType: 'Account Type',
          method: 'Method',
          serverName: 'Server name',
          urlLocation: 'Url location',
          fax: 'Fax',
          oldServerId: 'Old Employee ID',
          newServerId: 'New Employee ID',
          acivateTwilio: 'Activate Twilio',
          acivateSinch: 'Activate Sinch',
          isDriver: 'Is a Driver',
          monthy: 'Monthly',
          anual: 'Annual',
          merchantOnboardingApplication: 'Merchant Onboarding Application',
          applicationName: 'Application Name',
          agentId: 'Agent ID',
          planId: 'Plan ID',
          dateOfBirth: 'Date Of Birth',
          equityOwnershipPercent: 'Equity Ownership Percentage',
          isPersonalGuarantor: 'Is Personal Guarantor?',
          bookablePackage: 'Is bookable package',
          showProgressBar: 'Show Progress Bar To Driver'
        },
        messages: {
          buttons: {
            ok: 'Ok',
            dismiss: 'Dismiss'
          },
          activatePaymentMethod: 'has been activated.',
          incorrectToken: 'The token sent is not correct.',
          activationMethodError: 'The activation method returned an error.',
          unexpectedError: 'An unexpected error has occurred.',
          savePaymentMethodSuccess:
            'The payment method settings have been saved.',
          savePaymentMethodError:
            'An error occurred while saving the payment method settings.'
        },
        validate: {
          emailExisteTitle: 'Email Already Exists',
          emailExistMessage: 'This email is already registered. Please use a different email address or ask the User to click on Forgot Password in the login screen.',
          validate: 'Validate',
          validateCategory: 'Validate category',
          validateCustomer: 'Validate customer',
          validateMenu: 'Validate menu',
          validateOtherCharge: 'Validate other charge',
          validateProduct: 'Validate item',
          validateShipping: 'Validate delivery',
          validateTable: 'Validate table',
          validateTax: 'Validate tax',
          validateUser: 'Validate user',
          validateRole: 'Validate role',
          validateSetting: 'Validate setting',
          validateOccupation: 'Validate occupation',
          validateVariantGroup: 'Validate choices',
          name: 'Name is required',
          image: 'Image is required',
          email: 'Email is required',
          phone: 'Phone is required',
          emailIncorrect: 'Email is incorrect',
          date: 'Date is required',
          selectedCategories: 'Selected categories is required',
          productMinNumber: 'Item min must be a number',
          productMaxNumber: 'Item max must be a number',
          productMinGreater: 'Item min greater than 0',
          productMaxGreater: 'Item max greater than 2',
          price: 'Price must be a number',
          priceGreater: 'Price must be greater than 0',
          product: 'You must select a item',
          costPriceNumber: 'Cost price must be a number',
          retailPriceNumber: 'Sale price must be a number',
          retailPriceShouldBeGreaterThanSalePrice:
            'Retail Price should always be greater than the Sale Price',
          costPriceGreater: 'Cost price must be greater than 0',
          retailPriceGreater: 'Sale price must be greater than 0',
          category: 'You must select a category',
          capacity: 'Capacity must be a number',
          capacityGreater: 'Capacity must be greater than 0',
          percent: 'Percent must be a number',
          percentGreater: 'Percent must be greater than 0',
          password: 'Password is required',
          address: 'Address is required',
          title: 'Title is required',
          subtitle: 'Subtitle is required',
          zipCode: 'The zip code is not a valid zip code',
          duplicateZipCode: 'Duplicate zip code',
          cateringPriceZero: 'The catering price is zero',
          cooker: 'You must fill cook field',
          tableNumber: 'Table number must be a number',
          tableNumberGreater: 'Table number must be greater than 0',
          nameDuplicate:
            'There is a table with this name. You must change the number or the type.',
          firstName: 'You must fill first name field',
          lastName: 'You must fill last name field',
          confirmPassword:
            'The password and confirm password fields must be equal',
          occupation: 'You must fill the occupation field',
          notes: 'You must fill cancellation note field',
          tip: 'The tip cannot be zero',
          tipRepeat: 'The tip exist. Please, type a new number.',
          emailDontExist: 'Email does not exist.',
          ingredient: 'Ingredient already exists.'
        },
        permissionsGroup: {
          permissionMenu: 'MENU PERMISSION',
          permissionCategory: 'CATEGORY PERMISSION',
          permissionProduct: 'ITEM PERMISSIONS',
          permissionSpecialPrice: 'SPECIAL PRICE PERMISSIONS',
          permissionCustomer: 'CUSTOMER PERMISSIONS',
          permissionCredit: 'CREDIT PERMISSIONS',
          permissionHouseAccount: 'HOUSE ACCOUNT PERMISSIONS',
          permissionTable: 'TABLE PERMISSIONS',
          permissionTax: 'TAX PERMISSIONS',
          permissionShipping: 'DELIVERY PERMISSIONS',
          permissionOtherCharge: 'OTHER CHARGE PERMISSIONS',
          permissionUser: 'STAFF PERMISSIONS',
          permissionDriver: 'DRIVER SUPERVISION PERMISSIONS',
          permissionDeliveryDriver: 'DELIVERY DRIVER PERMISSIONS',
          permissionOrder: 'ORDER PERMISSIONS',
          permissionRole: 'ROLE PERMISSIONS',
          permissionWorkSheet: 'WORKSHEET PERMISSIONS',
          permissionSetting: 'SETTING PERMISSIONS',
          permissionPayment: 'PAYMENT PERMISSIONS',
          permissionReport: 'REPORTS PERMISSIONS',
          permissionClockin: 'CLOCK-IN PERMISSIONS',
          permissionOccupation: 'OCCUPATION PERMISSIONS',
          permissionVariantGroup: 'CHOICES PERMISSIONS',
          permissionReservation: 'RESERVATION PERMISSIONS',
          permissionSuscriptors: 'SUBSCRIBERS PERMISSIONS',
          permissionSuscription: 'SUBSCRIPTION PERMISSIONS',
          canViewMenu: 'Can view menus',
          canCreateMenu: 'Can create menus',
          canEditMenu: 'Can edit menus',
          canDeleteMenu: 'Can delete menus',
          canViewCategory: 'Can view categories',
          canCreateCategory: 'Can create categories',
          canEditCategory: 'Can edit categories',
          canDeleteCategory: 'Can delete categories',
          canViewProduct: 'Can view item',
          canCreateProduct: 'Can create item',
          canEditProduct: 'Can edit items',
          canDeleteProduct: 'Can delete items',
          canViewSpecialPrices: 'Can view special price',
          canCreateSpecialPrices: 'Can create special price',
          canEditSpecialPrices: 'Can edit special price',
          canDeleteSpecialPrices: 'Can delete special price',
          canViewCustomer: 'Can view customers',
          canCreateCustomer: 'Can create customers',
          canEditCustomer: 'Can edit customers',
          canDeleteCustomer: 'Can delete customers',
          canViewCredit: 'Can view credits',
          canCreateCredit: 'Can create credits',
          canEditCredit: 'Can edit credits',
          canDeleteCredit: 'Can delete credits',
          canViewHouseAccount: 'Can view house account',
          canCreateHouseAccount: 'Can create house account',
          canCreateSuscriptor: 'Can create subscribers',
          canViewSuscriptor: 'Can view subscribers',
          canEditSuscriptor: 'Can edit subscribers',
          canDesactivateSuscriptor: 'Can deactivate subscribers',
          canViewTable: 'Can view tables',
          canCreateTable: 'Can create tables',
          canEditTable: 'Can edit tables',
          canDeleteTable: 'Can delete tables',
          canViewTax: 'Can view taxes',
          canCreateTax: 'Can create taxes',
          canEditTax: 'Can edit taxes',
          canDeleteTax: 'Can delete taxes',
          canViewShipping: 'Can view shippings',
          canCreateShipping: 'Can create deliveries',
          canEditShipping: 'Can edit deliveries',
          canDeleteShipping: 'Can delete deliveries',
          canViewOtherCharge: 'Can view other charges',
          canCreateOtherCharge: 'Can create other charges',
          canEditOtherCharge: 'Can edit other charges',
          canDeleteOtherCharge: 'Can delete other charges',
          canViewUser: 'Can view users',
          canCreateUser: 'Can create users',
          canEditUser: 'Can edit users',
          canDeleteUser: 'Can delete users',
          canViewDriver: 'Can view external drivers',
          canCreateDriver: 'Can create external drivers',
          canEditDriver: 'Can edit external drivers',
          canDeleteDriver: 'Can delete external drivers',
          canViewDeliveryDriver: 'Can View Delivery Driver',
          canEditDeliveryStatus: 'Can Edit Delivery Status',
          canCreateDeliveryDriver: 'Can Create Delivery Driver',
          canDeleteDeliveryDriver: 'Can Delete Delivery Driver',
          canViewOccupation: 'Can view occupation',
          canCreateOccupation: 'Can create occupation',
          canEditOccupation: 'Can edit occupation',
          canDeleteOccupation: 'Can delete occupation',
          canViewRole: 'Can view roles',
          canCreateRole: 'Can create roles',
          canEditRole: 'Can edit roles',
          canDeleteRole: 'Can delete roles',
          canViewWorkSheet: 'Can view worksheet',
          canCreateWorkSheet: 'Can create worksheet',
          canEditWorkSheet: 'Can edit worksheet',
          canDeleteWorkSheet: 'Can delete worksheet',
          canViewOrder: 'Can view orders',
          canEditOrder: 'Can edit orders',
          canCreateOrder: 'Can create orders',
          canViewOrderForDelivery: 'Can view orders for delivery',
          canChangeSetting: 'Can change settings',
          canViewVariantGroup: 'Can view choices',
          canCreateVariantGroup: 'Can create choices',
          canEditVariantGroup: 'Can edit choices',
          canDeleteVariantGroup: 'Can delete choices',
          canViewReservation: 'Can view reservation',
          canCreateReservation: 'Can create reservation',
          canEditReservation: 'Can edit reservation',
          canDeleteReservation: 'Can delete reservation',
          canViewPayment: 'Can view payments',
          canIgnoreClockin: 'Can ignore clock in',
          canViewSalesByCustomer: 'Can view Sales By Customer',
          canViewSalesByProduct: 'Can view Sales By Product',
          canViewDynamicReports: 'Can view Dynamic Reports',
          canViewSubscription: 'Can view Subscription',
          canCreateSubscription: 'Can Create Subscription',
          canEditSubscription: 'Can Edit Subscription',
          canDeleteSubscription: 'Can delete Subscription'
        },
        marketingMessages: {
          orderInfo: 'Order information',
          inKitchen:
            ', Hello! Thank you for using our service. Your order is right now in our kitchen.',
          cooked: 'Your order is ready. It looks great!',
          delivering:
            'Your order is on its way right now. Just a few minutes, please',
          delivered: 'Your order has been delivered. Bon Appétit!',
          canceled: 'Your order has been canceled',
          cateringApproved:
            ', Your catering order has been approved. Please, check your email for order details.',
          cateringCancel: ', sorry, your catering order has been canceled.',
          reservationChangeStatus: 'Reservation change status',
          reservationApproved:
            ', Hello! Your reservation has been approved for ',
          reservationApproved2: ', you need confirm the reservation now.',
          reservationProposedDateTime:
            ', Hello! We regret that we cannot meet the date/time requested by you. We propose a new date/time: ',
          reservationRejected:
            ', Hi! We are sorry to have to decline your reservation due to lack of capacity.',
          reservationCancel:
            'Your reservation has been canceled. If you have any questions, do not hesitate to contact us.'
        }
      }
    },
    frontend: {
      menu: {
        clockInMessage: 'You have successfully clocked in',
        signIn: 'Sign In',
        chatImenu: 'iMenuApps® Support',
        trackYourPackage: 'Track your package',
        aboutImenu: 'About iMenuapps®',
        seeLess: 'See less',
        seeMore: 'See more',
        foodAndMoodJournal: 'Food and Mood Journal',
        motivation: `To view your order history, download the iMenuApps® application and register.
             <a href="https://apps.apple.com/us/app/imenuapps/id1574771438" target="_blank">Download on the Apple App Store</a> or 
             <a href="https://play.google.com/store/apps/details?id=net.imenuapps.apps&hl=en_US&pli=1" target="_blank">Get it on Google Play</a>.`,
        motivationMobile:
          'To view your order history, register with iMenuApps®.',
        menu: 'Menu',
        shop: 'Shop',
        ads: 'Digital Signage',
        credit: 'Credits',
        menuCatering: 'Catering Menu',
        pickupRequest: 'Pickup Request',
        termsOfUse: 'Terms of Use',
        privacyPolicy: 'Privacy Policy',
        otherPolicy: 'Other Policies',
        reservation: 'Reservations',
        about: 'About Us',
        chat: 'Chat',
        eMarkeeting: 'eMarketing',
        contact: 'Contact Us',
        oferts: 'Offer',
        init: 'Home',
        loginMerchant: 'Merchant Login',
        loginClient: 'Client Login',
        editProfile: 'Edit your profile',
        edit: 'Edit your data',
        log: 'Sign In / Register',
        membersLogin:'Members Login',
        membersRegister: 'Members Register',
        merchantsLogin:'Merchants Login',
        catering: 'Catering Service',
        logout: 'Logout',
        logIn: 'Login',
        profil: 'My Account',
        profil1: 'Profile',
        createUser: 'Register',
        forgotPassword: 'Did you forget your password?',
        passwordReset: 'Password Reset',
        newPassword: 'New Password',
        newData: 'Modify your Data',
        confirmPassword: 'Confirm Password',
        register: 'Register',
        orders: 'Orders',
        restaurant: 'Click below to select Business Type',
        restablacerPassword: 'Reset Password',
        updateData: 'Update Data',
        mssForgotPassword: 'We have sent a new password to your email.',
        errorLogIn: 'Incorrect email or password',
        errEmailExist: 'This email already exists',
        errPassNotCoinc: 'It does not match the new password',
        userNotFound: 'Incorrect email',
        refresh: 'Refresh',
        mssUpdateData: 'Your data was updated correctly',
        mssCreateUser:
          'Customer created successfully, we have sent your new password via e-mail.',
        mssPasswordChangedCorrectly: 'Successfully updated your password',
        ticketMenu: 'Open Ticket'
      },
      app: {
        convertToProd: 'Convert Trial To Production',
        convert: 'Convert',
        daysOfTrial: 'Days of Trial',
        trialExpired: 'Trial Expired',
        trialMessageExpired: 'Your free trial of iMenuApps® has expired. To continue using the full power of iMenuApps®, purchase a license now and unlock all features. Please email us with your business name to support@imenuapps.com',
        allBusiness: 'All Businesses',
        hospitality: 'Hospitality',
        reservations: 'Reservations',
        service: 'Service',
        entertainment: 'Entertainment',
        retail: 'Retail',
        fullText:
          'Introducing iMenuApps®: Your Comprehensive Business Solution with Enhanced Client Portal iMenuApps® presents an all-encompassing platform designed to fulfill every business need, revolutionizing the way you operate and connect with your customers. Our application not only empowers businesses to streamline operations and boost sales but also incorporates a cutting-edge client portal that enhances the customer experience. With our client portal, customers can effortlessly re-order products and services and maintain a comprehensive record of their transactions and profiles with each merchant they engage with on our platform. This feature fosters convenience, efficiency, and personalized interactions, ultimately strengthening the bond between businesses and their valued clients. Whether you operate in Hospitality, Retail, Service, or Entertainment, iMenuApps® is the ultimate solution tailored to your industry-specific requirements. Our advanced platform seamlessly integrates the client portal, enabling businesses to provide a seamless and personalized experience to their clientele. Embrace iMenuApps® and unlock a world of possibilities for your business. Benefit from our intuitive user interface, robust functionality, and secure infrastructure, all geared towards optimizing operations and fostering long-lasting customer relationships.',
        thisPay: 'This Payment Was Made',
        thisPayDone: 'This payment has already been made.',
        selectOrder: 'Select Your Order Type',
        selectDetail: 'Your data information',
        deliver: 'Delivery',
        pickup: 'Pick-Up',
        table: 'Table',
        curbside: 'Curbside',
        notClient:
          'There are no orders associated with this client. Remember that only registered customers can view their orders.',
        getOrder: 'To get orders',
        editTitle: 'Edit your Data',
        notPermissionForRating: 'Only registered users can rate a business',
        thanksForRating: 'Thanks for your rating',
        sessionExpired:
          'Your session has expired due to inactivity. Please log in again.',
        notRestaurantFound:
          'The requested business does not exist. We hope you find another one of your preference in our list.',
        all: 'All',
        productsAndServices: 'Sales',
        reservation: 'Bookings'
      },
      product: {
        title: 'Items of',
        back: 'Back',
        noProducts: "Oops! Sorry, this category doesn't have items yet. ",
        productDetail: 'Item Detail',
        massageToast: 'Successful ',
        productNote: 'Enter your item note here...',
        productWithVariant: 'Click ADD for other choices'
      },
      home: {
        country: 'Country',
        stateProvince: 'State/Province/Region',
        county: 'County',
        autocomplete:
          'Start entering your address here so it can auto populate',
        selectCategory: 'Menu categories',
        cardTitle: 'Cart details',
        cardheader: 'Items',
        cancel: 'Cancel',
        acept: 'Ok',
        confirm: 'Confirm',
        clear: 'Clear',
        checkout: 'Check Out',
        deliverDetail: 'Delivery Details',
        address: 'Address',
        pickupDetail: 'Pick-Up Details',
        curbsideDetail: 'Curbside Details',
        cateringDate: 'Catering Date',
        pickTime:
          'Pick-Up time not available. Please choose another pick-up time',
        tableQr: 'Location QR',
        notValidQr: 'Not a valid QR',
        notSeatAvailable: 'This seat is already assigned',
        errorRequired: 'Insert required information',
        errorDateNotValid: 'Date not valid',
        noProductForReorder:
          'There is no availability of any item for re-order.',
        noProductAvailable:
          'The following items do not appear in the order, because they are not available today.',
        clientRequired: 'Action allowed only for registered users. Log in.',
        cantNotValid: 'The item quantity is not valid',
        zipCodeNotValid: 'Zip Code not Valid.',
        notZoneToDeliver: 'We currently do not deliver in this area.',
        state: 'State',
        city: 'City',
        notValidEmail: 'Not a Valid Email',
        reqSuccess: 'Successfully Submitted the Change Request!',
        approveSuccess: 'Successfully Approved the Change Request!',
        alertDeleteData: 'Do you want to start over?',
        notTimeToPick: 'Pick-Up hours are between: ',
        cookTime: '. The estimated time for cooking is ',
        priceEstimated: 'Estimated Price',
        minuts: ' Minutes.',
        selectOrderType: 'Please choose your order type.',
        search: 'Search',
        aggregateFree: 'Included Free',
        sides: 'Sides',
        choises: 'Ingredients',
        variants: 'Variants',
        withoutIngredients: 'Without ingredients',
        eventType: 'Event Type',
        emailSended: 'Email sent',
        choseView: 'Optional Views',
        applicationCreateSuccess: 'Application Created Successfully',
        applicationCreateError: 'Error occurred while creating application'
      },
      genderOptions: {
        male: 'Male',
        female: 'Female',
        nonBinary: 'Non-Binary',
        transgenderMale: 'Transgender Male',
        transgenderFemale: 'Transgender Female',
        genderqueer: 'Genderqueer',
        genderfluid: 'Genderfluid',
        agender: 'Agender',
        twoSpirit: 'Two-Spirit',
        bigender: 'Bigender',
        demiboy: 'Demiboy',
        demigirl: 'Demigirl',
        androgynous: 'Androgynous',
        intersex: 'Intersex',
        neutrois: 'Neutrois',
        pangender: 'Pangender',
        polygender: 'Polygender',
        preferNotToSay: 'Prefer Not to Say',
        other: 'Other'
      },
      orderType: {
        customerType: 'Customer Type',
        lastContacted: 'Last Contacted',
        nextFollowUp: 'Next Follow Up',
        preferredContactTime: 'Preferred Contact Time',
        preferredContactToTime: 'Preferred Contact To Time',
        order: 'Order',
        invoice: 'Invoice',
        quote: 'Quote',
        email: 'Email',
        password: 'Password',
        emailPhone: 'Email and Phone',
        name: 'First Name and Last Name',
        phone: 'Phone',
        address: 'Address',
        code: 'Zip Code',
        pickDate: 'Pick-Up Date',
        pickOut: 'Pick-Up Time',
        licencePlate: 'License Plate',
        vehicleModel: 'Vehicle Make/Model',
        vehicleColor: 'Vehicle Color',
        contactedBy: 'Contact via',
        tellContact: 'Tell us how to best contact you',
        worker: 'Employee',
        minAmountDelivery: 'Catering minimum amount',
        minAmountPickUp: 'Pick Up Catering minimum amount'
      },
      reservation: {
        availability: 'Weekly reservation time',
        reservations: 'Reservations',
        reservationDetail: 'Reservation Detail',
        create: 'New Reservation',
        reservationDate: 'Reservation Date',
        reservationHour: 'Reservation Hour',
        timezone: 'Timezone',
        peoples: 'People',
        serviceTime: 'Estimate Service Time',
        reason: 'Occasion',
        find: 'Search for a Reservation',
        enterCode: 'Enter the code',
        yoursReservations: 'Reservations',
        code: 'Code',
        completeDateReservacion: 'Date',
        notcodefind: 'No reservation found associated with this code',
        state0: 'Request',
        state1: 'Approved',
        state2: 'Proposed Date / Time',
        state3: 'Rejected',
        state4: 'Confirm',
        state5: 'Cancel',
        state6: 'Close',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Sunday: 'Sunday',
        all: 'All',
        restaurantHour: 'Business hours',
        open: 'Open',
        close: 'Close Now, Continue to Page',
        errorHourCaterin: 'Catering time for ',
        errorHour: 'Reservation time for ',
        errorHour2: ' is from ',
        discount: 'Discount',
        orderCloseToDiscount:
          "This Reservation is closed, and you can't use this Quotation Payment.",
        subtotalNotForDiscount:
          "You can't use this Quotation Payment because is bigger than Subtotal.",
        notDiscountToApply: 'No discount to apply',
        restaurantNotes: 'Business Note',
        quotationMessage1: 'Our prepaid dinner rate is  ',
        quotationMessage2:
          'and this amount will be deducted from your order if you place an order with us. ',
        dinnerPrePayment: 'Prepaid dinner',
        timeToReserve: 'Duration in minutes ',
        available: 'Availability',
        notAvailable: 'No Availability',
        deposit: 'Reservation Deposit',
        seatsAvailable: ' Seats Available',
        guestLocation: 'Select the location of all your guests',
        notGuestAvaibility: 'There is no availability for all your guests',
        selectStaff: 'Select a staff'
      },
      order: {
        item: 'Item',
        description: 'Description',
        quantity: 'Qty',
        taxable: 'Taxable?',
        amount: 'Amount',
        tip: 'Tip',
        discount: 'Discount',
        creditCardFee: 'Credit Card Fee',
        shipping: 'Shipping',
        trackShipping: 'Track Shipping',
        packagesManagement: 'Packages Management',
        tax: 'Tax',
        deposit: 'Deposit',
        pendingAcceptance: 'Pending Acceptance',
        accepted: 'Accepted',
        prepare: 'Prepared',
        email: 'E-mail',
        phone: 'Phone',
        goBack: 'Go Back',
        orderDetail: 'Order Details',
        quoteDetail: 'Quote Details',
        convertInvoice: 'Convert To Invoice',
        aceptQuote: 'Accept Quote',
        productServicesUpdated: 'Products/Services updated',
        payInvoive: 'Pay Invoice',
        invoiceDetail: 'Invoice Details',
        invoiceNumber: 'Invoice No.',
        invoiceTerm: 'Terms',
        invoicePayed: 'Your invoice has been paid',
        shippingDate: 'Shipping Date',
        shippingVia: 'Shipping Via',
        shippingTo: 'Shipping To',
        shippingFrom: 'Shipping From',
        shippingTrackingNumber: 'Tracking Number',
        client: 'Client',
        cart: 'Cart',
        productsOrdered: 'Products Ordered',
        products: 'Items',
        name: 'Name',
        cant: 'Qty',
        price: 'Price',
        total: 'Total',
        otherCharges: 'Other Charges',
        quotationPayment: 'Quotation payment',
        cashPayment: 'Cash Payment',
        isTicket: 'Open order as ticket',
        payAsTicket: 'Authorize payment ',
        sendInvoice: 'Send invoice ',
        saveAsTicket: 'Save Ticket',
        checkPayment: 'Check Payment',
        parcialPayment: 'Partial Payment',
        quotationMessage1: 'Our fee for quoting is ',
        quotationMessage2:
          'and this amount will be deducted from your order if you order from us. ',
        pendingPayment: 'Pending payment',
        subtotal: 'Subtotal',
        taxe: 'Taxes',
        deliver: 'Delivery',
        tip: 'Tip',
        notes: 'Notes',
        payment: 'Payment Detail',
        ccard: 'Credit Card',
        ccode: 'Card Code',
        payWithThisCardQuestion: 'Do you want to pay with this Card?',
        cardEndingIn: 'Card ending in',
        yesPayNow: 'Yes, pay now',
        paymentSuccessful: 'Payment Successful',
        paymentProcessed: 'Your payment was processed successfully',
        expcard: 'Expiration Date',
        dueDate: 'Due Date',
        pay: 'Pay',
        verify: 'Verify Payment',
        transictionTitle: 'Transaction status',
        transictionOk: 'Your transaction was successful',
        sendRequest: 'Send request',
        requestCatering:
          'Request sent. The business manager will contact you shortly.',
        transictionError: 'Error executing payment',
        notValidCC: 'Invalid credit card number',
        yourOrders: 'Orders ',
        yourTicket: 'Tickets ',
        seeAll: 'See All Orders',
        orderState: ' Order State',
        cooker: ' Cook',
        type: 'Type',
        state: 'State',
        messageToast:
          "Simply register to track your orders and view your order history. It's that easy!",
        messgForContact:
          "Simply register to track your orders and view your order history. It's that easy!",
        messgForContactCatering: 'You must login to create Catering order',
        date: 'Date',
        state0: 'Pending payment',
        state1: 'Paid',
        state2: 'In Kitchen',
        state3: 'Prepared',
        state4: 'On the way',
        state5: 'Delivered',
        state6: 'Cancelled',
        state7: 'Pending Review',
        state8: 'Catering Approved',
        state9: 'Quote',
        state10: 'Order Picked Up',
        state11: 'Delayed',
        state12: 'Voiding',
        state13: 'Refunded',
        notOrder: 'You have no pending orders',
        transId: 'Transaction',
        invoice: 'Invoice',
        invoiceProposal: 'Invoice Proposal',
        invoiceProposalUpdated: 'Invoice Proposal Updated',
        add: 'Add',
        share: 'Share',
        remove: 'Remove',
        edit: 'Edit',
        cancelReason: 'Reason for cancellation',
        paymentMethod: 'Payment Method',
        orderFor: 'Order for',
        other: 'Other',
        noTip: 'No Tip',
        payed: 'Paid',
        toPay: 'To Pay',
        readyForPick:
          ' You will receive a text or email when your order is ready for pickup.',
        location: 'Location',
        hourToPickEstimated: 'Estimated Pick-Up Time',
        dateToPickEstimated: 'Estimated Pick-Up Date',
        routingNumber: 'Bank Routing Numbers',
        accountNumber: 'Account number',
        bankName: 'Name of the bank',
        badroutingNumber: 'Incorrect bank routing number',
        eventName: 'Event Name',
        guessNumber: 'Number of Guests',
        eventDate: 'Event Date',
        messageDevice: 'Please contact Support at iMenuApps® to add a device 973-969-1909 or support@solutionsforsuccess.net',
        eventStartHour: 'Event Start Time',
        eventEndHour: 'Event End Time',
        warningProductsTheOrderToCatering:
          'You are trying to add an item that is NOT from the Catering Service. If you want to continue, you will lose the items previously added. ',
        warningProductsTheCateringToOrder:
          'You are trying to add a Catering Service item. If you want to continue, you will lose the items you added previously. ',
        clientInfo: 'Client information',
        orderType: 'Order Type',
        paymentByCard: 'Pay by Credit Card',
        totalForPay: 'Total to pay',
        firstName: 'First name',
        lastName: 'Last name',
        postalCode: 'Postal Code',
        addressLine1: 'Address',
        updateTicket: 'Update Ticket',
        closeTicket: 'Close Ticket',
        closed: 'Closed',
        requiredCustomer: 'Client Data',
        requiredOrderType: 'Order Type',
        culumnNumber: 'Number of columns in the row'
      },
      tooltips: {
        addOrder: 'Add',
        printOrder: 'Print',
        forward: 'Forward',
        reOrder: 'Reorder',
        refreshOrder: 'Refresh',
        refreshCaptcha: 'Refresh Captcha',
        deleteOrder: 'Remove',
        readyProduct: 'Ready',
        printRes: 'Print',
        shareLocation: 'Share Location',
        closeTicket: 'Close',
        editTicket: 'Edit',
        loadInfo: 'Loading your data',
        loadRestaurant: 'Loading...',
        getToRestaurant: 'Click Here When You Get To business location',
        carInRestaurant: 'The car arrived at the business',
        carArrivedInfo:
          'Thank you for letting us know that your car has arrived',
        errorRestaurantOffline: 'This business is not visible to the public',
        deliveryPayment: 'Delivery Payment'
      },
      payment: {
        splitPayment: 'Split Payment',
        splitIn: 'Divide into',
        splitMss:
          'The amounts to be paid must cover the Total amount of the Order. No payment can be 0 ',
        splitPay: 'Payment #',
        splitToPay: 'Pay',
        splitPayed: 'Paid',
        tjtPayment: 'Card',
        creditPayment: 'Credit',
        devicePayment: 'Device',
        idtechPayment: 'Moto/Swipe',
        swipePayment: 'Swipe',
        cashPayment: 'Cash',
        hcaPayment: 'ACH',
        housePayment: 'Home Account',
        checkPayment: 'Check',
        sharePayment: 'Share Pay',
        qrPayment: 'QR Payment',
        verifyMss:
          'After knowing that your payment has been made, Verify the payment to save the order, or Cancel to not continue this payment.',
        doingPayment: 'Paying',
        authorizingPayment: 'Authorizing payment',
        insuficientFunds: 'Insufficient funds',
        quoteExpired: 'Sorry. The time for this proposal has expired',
        quoteChanged: 'The proposal has been modified, it is in status',
        quoteAcepted: 'The proposal has been accepted',
        goodPayment: 'Paid',
        shareText1:
          ' shared a payment link for the food order placed in our business ',
        shareText1a:
          ' shared a payment link for the reservation made at our business  ',
        shareText2:
          '. Please follow the link below to make the payment.  Thank you!'
      },
      createNew: {
        businessTemplate: 'Business template',
        restaurantName: 'Business name',
        restaurantAddres: 'Business address',
        restaurantPhone: 'Business phone',
        restaurantEmail: 'Business email',
        restaurantZipcode: 'Business zipcode',
        restaurantWeb: 'Business website',
        restaurantFax: 'Business fax',
        merchantName: 'Merchant first name',
        merchantLastName: "Merchant's last name",
        merchantAddres: 'Merchant address',
        merchantZipcode: 'ZipCode',
        merchantPhone: 'Merchant phone number',
        merchantEmail: 'Email of the merchant',
        merchantClerk: 'User Pin (1 - 99999)',
        createTitle: 'Create new business in iMenuApps®',
        dataRestaurant: 'Business details',
        dataMercahnt: 'Merchant data',
        restaurants: 'Businesss',
        createdMessage:
          'The business was created successfully. You will receive an email with the password to access the application ',
        clerkToLong: 'Pin value exceeded, maximum allowed 99999',
        clerkNotValid: 'Not a valid Pin',
        reciveSubscription: 'You want to receive notifications from',
        activateSubscription: 'You want to activate notifications for',
        saving: 'Saving business',
        recordSaving: 'Saving',
        active: 'Active',
        inactive: 'Not active',
        restaurantType: 'Business Type',
        template: 'Template',
        chooseBusinessTemplate: 'Choose business template',
        select: 'Select',
        temrsAndCondition: 'Terms and Conditions',
        trialDate: '-day trial',
        trialMss: 'Try for 14 days',
        business: 'Business',
        reservation: 'Reservation'
      },
      unsubscribe: {
        title: 'Unsubscribe',
        email: 'Email',
        unsubscribeOk: 'Your email has been unsubscribed successfully',
        unsubscribeFail: 'Error. Mail not found ',
        restaurantFail: 'Business not found'
      },
      specialsPrice: {
        titles: 'Special Prices',
        title: 'Special Price',
        name: 'Name',
        type: 'Type',
        amount: 'Amount',
        for: 'To',
        apply: 'Apply',
        active: 'Active',
        repite: 'Repeat',
        oneStarDate: 'Start Date and Time',
        oneEndDate: 'End Date and Time',
        weekStarDate: 'Start Time',
        weekEndDate: 'End Time',
        monthStardDat: 'Day of the month',
        annualStartDat: 'Month and Day of the year',
        activeRule:
          'Only one rule at a time will be applied. The first one activated will take precedence.'
      },
      credit: {
        state0: 'Requested',
        state1: 'Accepted',
        state2: 'Cancelled',
        state3: 'Close',
        yourCredit: 'Your credits',
        amount: 'Credit amount',
        debt: 'Debt',
        createDate: 'Creation date',
        active: 'Active',
        dateFrom: 'Start date',
        dateTo: 'End Date',
        paymentDate: 'Payment date',
        state: 'State',
        pendingPay: 'Pending payment',
        payed: 'Paid',
        creditpayed: 'Credit Paid',
        mssPay1: 'The customer ',
        mssPay2: 'have made a credit payment ',
        mssPay3: 'for an amount '
      }
    }
}